import { Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import {  Subject } from 'rxjs';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
var moment = require('moment');
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { CommitteeService } from 'src/app/services/committee.service';
import { DataArray } from 'src/app/helpers/datalist';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
@Component({
  selector: 'app-director-add-edit',
  templateUrl: './director-add-edit.component.html',
  styleUrls: ['./director-add-edit.component.css']
})
export class DirectorAddEditComponent implements OnInit {

  public environmentSettings: any;
  datesSelected: NgbDateStruct[] = [];


  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptions: DataTables.Settings = {};
  dtOptionsOfDirectorship: DataTables.Settings = {};
  dtOptionsOfSubDirector: DataTables.Settings = {};
  dtOptionsOfRelative: DataTables.Settings = {};
  directorMasterForm: FormGroup;
  directorProfessionalDetailsForm: FormGroup;
  directorContactDetailsForm: FormGroup;
  directorshipForm: FormGroup;
  subDirectorForm: FormGroup;
  relativesForm: FormGroup;
  dtTriggerOfDirectorship: Subject<any> = new Subject();
  dtTriggerOfSubDirector: Subject<any> = new Subject();
  dtTriggerOfRelative: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: "" };
  stateListArray: any;
  designationArray: any;
  categoryArray: any;
  cessationArray: any;
  bodycorporateArray: any;
  bodycorporateArrayInRelative: any;
  directorshipArray: any;
  allDirectorshipArray: any;
  subdirectorarray: any;
  natureOfIntrestArray: any;
  natureOfIntrestArrayInRelative: any;
  relationArray: any;
  committeeArray: any;
  DateOfBirthModel: any;
  BoardResolutionDateModel: any;
  AppointmentDateModel: any;
  IntrestDateModel: any;
  IntrestChangeDateModel: any;
  ReAppointmentDateModel: any;
  dirAppointmentDateModel: any;
  dirCessationDateModel: any;
  AcquisitionDateModel: any;
  DisposalDateModel: any;
  AppointmentDIR12FillingDateModel: any;
  CessationDateModel: any;
  ResignationDIR11filingDateModel: any;
  AppointmentCompletionDateModel: any;
  DisqualificationDateModel: any;
  RemovalDateModel: any;
  PreAppointmentDateModel: any;
  NoticeReceivedDateModel: any;
  RemovalDIR12FilingDateModel: any;
  ResignationEffectiveDateModel: any;
  DesignationDIR12FillingDateModel: any;
  DSCSigningDateModel: any;
  updateButtonhide: any;
  saveButtonhide: any;
  saveProfessionalButton: any;
  saveContactButton: any;
  updateProfessionButton: any;
  updateContactButton: any;
  updatedirectorshipButtonhide: any;
  updatesubDirectorButtonhide: any;
  saveRelativeButton: any;
  updateRelativeButton: any;
  relativesArray: any;
  searchPAN: string;
  showMarridYes: boolean;
  deleteDirectorshipID: any;
  deleteSubDirectorID: any;
  deleteRelativeID: any;
  showDormantState: any;
  NumberOfSecuritiesModel: any;
  NumberOfSharesDisposedModel: any;
  cumulativeBalanceModel: any;
  IsNumberOfSharesLarge: boolean;
  IsNumberOfSecurityLess: boolean;
  showCIN: boolean;
  showCINRelative: boolean;
  showDormantStateRelative: boolean;
  showOtherCompany: boolean;
  showOtherNatureOfIntrest: boolean;
  showShareHolding: boolean;
  preAppointmentsDateArray: any[];
  showShareholdingInRelative: boolean;
  showOtherCompanyForRelative: boolean;
  showOtherNatureForRelative: boolean;
  disableOfficeName: boolean;
  ShowOtherCessationType: boolean;
  cessationDateIsPrior: boolean;
  selectAppointmentDate: boolean;
  showCommitee: boolean;
  showOtherCommitee: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  TodayDate: NgbDateStruct;
  FutureCessationDate: NgbDateStruct;
  FutureRemovalDate: NgbDateStruct;
  FutureDSCSigningDate: NgbDateStruct;
  FutureCessationDateInDirectorship: NgbDateStruct;
  FutureDisposalDateInSubdirector: NgbDateStruct;
  FutureReappointmentDate: NgbDateStruct;
  FutureDIR12FillingDate: NgbDateStruct;
  IsCessationDatePriorInProfessional: boolean;
  IsRemovalDatePriorInProfessional: boolean;
  IsCessationDatePriorInDirectorship: boolean;
  IsDisposalDatePriorInSubdirector: boolean;
  IsReappointmentDatePriorInProfessional: boolean;
  IsDIR12FillingDatePriorInProfessional: boolean;
  FromDateModelInDirectorship: any;
  ToDateModelInDirectorship: any;
  FromDateModelInSubDirector: any;
  ToDateModelInSubDirector: any;
  FromDateModelInRelative: any;
  ToDateModelInRelative: any;
  FutureAppointmentDate: boolean;
  IsReappointmentDateLaterInProfessional: boolean;
  globalDirectorshipID: any;
  globalSubdirectorID: any;
  globalRelativeID: any;
  IsDateOfBirthValid: boolean;
  IsInterestChangeDatePriorInRelative: boolean;
  FutureIntrestChangeDate: NgbDateStruct;
  futureFromDateInDisclosure: NgbDateStruct;
  futureToDateInDisclosure: NgbDateStruct;
  futureToDateInDetailsOfSecurity: NgbDateStruct;
  futureFromDateInDetailsOfSecurity: NgbDateStruct;
  futureFromDateInRelative: NgbDateStruct;
  futureToDateInRelative: NgbDateStruct;
  adjustEditHistoryBoxWidth: any;
  response: boolean;
  showmsgflag: boolean;
  dinnum: any;
  dateOfIncorpOfCompany: any;
  disabledAppointmentDateDirector: boolean = false;

  constructor(private DirectorMasterService: DirectorMasterService,
    private alert: AlertComponent,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private router: Router,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,
    private committeeService: CommitteeService,) {
    this.response = false;

  }


  
  ngOnInit() {
    this.getInCorpDate();
    $("#saveUpdateDirector").html('<i class="fa fa-save"></i>Save');
    localStorage.setItem('checktab', " ");

    try {
      var checkdinstring = localStorage.getItem('checkdin');
      console.log(checkdinstring, '<---------------');
      if (checkdinstring) {
        this.showmsgflag = checkdinstring.includes("checkdin");
      } else {
        this.showmsgflag = false;
      }

    } catch (exception) {
      this.showmsgflag = false;
    }


    // console.log("url", checkdinstring.includes("checkdin"));

    this.environmentSettings = environment;
    this.adjustEditHistoryBoxWidth = 0;
    // this.commonFunction.removeDataTableSaveStateKey("directorshipTable");
    // this.commonFunction.removeDataTableSaveStateKey("subDirectorTable");
    // this.commonFunction.removeDataTableSaveStateKey("relativeTable");

    this.stateListArray = DataArray.stateList;
    this.designationArray = DataArray.nonExecutiveDesignationList;
    this.categoryArray = DataArray.categoryList;
    this.cessationArray = DataArray.cessationTypeList;
    this.getCompanyTypeInDisclosureOfIntrest();
    this.getNatureOfInterestInDisclosureOfIntrest();
    this.bodycorporateArrayInRelative = DataArray.BodiesCorporate;
    this.natureOfIntrestArrayInRelative = DataArray.NatureOfIntrest;
    this.relationArray = DataArray.Relation;
    this.committeeArray = DataArray.Committee;
    this.directorshipArray = [];
    this.subdirectorarray = [];
    this.preAppointmentsDateArray = [];
    this.updateButtonhide = true;
    this.saveButtonhide = false;
    this.saveProfessionalButton = false;
    this.updateProfessionButton = true;
    this.saveContactButton = false;
    this.updateContactButton = true;
    this.updatedirectorshipButtonhide = true;
    this.updatesubDirectorButtonhide = true;
    this.saveRelativeButton = false;
    this.updateRelativeButton = true;
    this.showDormantState = false;
    this.showDormantStateRelative = false;
    this.showCINRelative = false;
    this.IsNumberOfSharesLarge = false;
    this.IsNumberOfSecurityLess = false;
    this.showCIN = false;
    this.showOtherCompany = false;
    this.showShareHolding = false;
    this.showShareholdingInRelative = false;
    this.showOtherCompanyForRelative = false;
    this.disableOfficeName = false;
    this.selectAppointmentDate = false;
    this.showCommitee = false;
    this.showOtherCommitee = false;
    this.IsCessationDatePriorInDirectorship = false;
    this.IsReappointmentDatePriorInProfessional = false;
    this.IsReappointmentDateLaterInProfessional = false;
    this.IsDIR12FillingDatePriorInProfessional = false;
    this.IsDisposalDatePriorInSubdirector = false;
    this.FutureAppointmentDate = false;
    this.IsDateOfBirthValid = true;
    this.IsInterestChangeDatePriorInRelative = false;
    this.getAllNations();

    $("#dinNumberFocus").focus();
    $('.select2').select2();
    $('.select2-tags').select2({
      tags: true,
      tokenSeparators: [',', ' ']
    });

    this.dtOptionsOfDirectorship = {
      //deferRender: true,
      stateSave: true,
      stateDuration: -1,
      destroy: true,
      scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [4] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };

    this.dtOptionsOfSubDirector = {
      stateSave: true,
      stateDuration: -1,
      destroy: true,
      scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [4] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],

    };

    this.dtOptionsOfRelative = {
      stateSave: true,
      stateDuration: -1,
      destroy: true,
      scrollY: "250px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [2] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],

    };

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });


    this.directorMasterForm = new FormGroup({
      Din: new FormControl('', [Validators.required, Validators.pattern("^([0-9]){8}?$")]),
      FirstName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z.'][a-zA-Z.' ]*$")]),
      MiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      LastName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      FatherFirstName: new FormControl('', [Validators.pattern("^[a-zA-Z.'][a-zA-Z.' ]*$")]),
      FatherMiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      FatherLastName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      MotherFirstName: new FormControl('', [Validators.pattern("^[a-zA-Z.'][a-zA-Z.' ]*$")]),
      MotherMiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      MotherLastName: new FormControl('', [Validators.pattern("^[a-zA-Z'][a-zA-Z' ]*$")]),
      DateOfBirth: new FormControl('', []),
      BirthPlace: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      Gender: new FormControl('', [Validators.required]),
      Nationality: new FormControl('null', []),
      Resident: new FormControl('', []),
      Occupation: new FormControl('', []),
      EducationalQualification: new FormControl('', []),
      // IsChairman: new FormControl('', [Validators.required]),
      EmailID: new FormControl('', [Validators.required]),
      PAN: new FormControl('', [Validators.required, Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      IsMarried: new FormControl('', []),
      SpouseFirstName: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      SpouseMiddleName: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      SpouseLastName: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")])
    });

    this.directorProfessionalDetailsForm = new FormGroup({
      IsExecutive: new FormControl('', [Validators.required]),
      IsRetiringDirector: new FormControl('', [Validators.required]),
      Designation: new FormControl('', [Validators.required]),
      Category: new FormControl('', [Validators.required]),
      PreAppointmentDates: new FormControl(''),
      PreAppointmentDatesList: new FormControl(''),
      BoardResolutionDate: new FormControl('', []),
      AppointmentDate: new FormControl('', [Validators.required]),
      AppointmentDIR12FillingDate: new FormControl('', []),
      ReAppointmentDate: new FormControl('', []),
      CessationDate: new FormControl('', []),
      CessationType: new FormControl('', []),
      ResignationDIR11filingDate: new FormControl('', []),
      CessationReason: new FormControl('', []),
      AppointmentCompletionDate: new FormControl('', []),
      DisqualificationDate: new FormControl('', []),
      DisqualificationDetails: new FormControl('', []),
      RemovalDate: new FormControl('', []),
      NoticeReceivedDate: new FormControl('', []),
      RemovalDIR12FilingDate: new FormControl('', []),
      ResignationEffectiveDate: new FormControl('', []),
      IsChairman: new FormControl('', [Validators.required]),
      OtherCessationType: new FormControl('', []),
      // EmailID: new FormControl('', [Validators.required])

      FunctionalAreas: new FormControl('', []),
      DesignationDIR12FillingDate: new FormControl('', []),
      PromoterGroupDirector: new FormControl('', []),
      IsSittingFeesEligible: new FormControl('', []),
      AllMeetingSittingFees: new FormControl('', []),
      MeetingAttendedNumber: new FormControl('', []),
      Commission: new FormControl('', []),
      Remuneration: new FormControl('', []),
      DSCSigningDate: new FormControl('', []),
      DisqualifiedDirector: new FormControl('', [])
    });


    this.directorContactDetailsForm = new FormGroup({
      isAddressSame: new FormControl('', []),
      PermenantResidentialAddress: new FormGroup({
        Line1: new FormControl('', []),
        Line2: new FormControl('', []),
        City: new FormControl('', []),
        Country: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
        State: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
        PinCode: new FormControl(''),
      }),
      PresentResidentialAddress:
        new FormGroup({
          Line1: new FormControl('', []),
          Line2: new FormControl('', []),
          City: new FormControl('', []),
          Country: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
          State: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
          PinCode: new FormControl(''),
        }),
      OfficeAddress: new FormGroup({
        Line1: new FormControl('', []),
        Line2: new FormControl('', []),
        City: new FormControl('', []),
        Country: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
        State: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
        PinCode: new FormControl(''),
      }),
      OfficeTelephoneNumber: new FormControl('', []),
      ResidentTelephoneNumber: new FormControl('', []),
      Fax: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      AadhaarNumber: new FormControl('', []),
      IdentityNumber: new FormControl('', []),
      PassportNumber: new FormControl('', []),
      DrivingLicenseNumber: new FormControl('', []),
      FunctionalAreas: new FormControl('', []),
      DesignationDIR12FillingDate: new FormControl('', []),
      PromoterGroupDirector: new FormControl('', []),
      IsSittingFeesEligible: new FormControl('', []),
      AllMeetingSittingFees: new FormControl('', []),
      Commission: new FormControl('', []),
      Remuneration: new FormControl('', []),
      DSCSigningDate: new FormControl('', []),
      // IsDirectorSupport: new FormControl('', []),
      DisqualifiedDirector: new FormControl('', []),
      MeetingAttendedNumber: new FormControl('', []),
    });
    this.setControls();

    this.directorshipForm = new FormGroup({
      OfficeName: new FormControl('', [Validators.required]),
      OfficeType: new FormControl('', []),
      CIN: new FormControl('', [Validators.pattern("^([a-zA-Z]){1}([0-9]){5}([a-zA-Z]){2}([0-9]){4}([a-zA-Z]){3}([0-9]){6}?$")]),
      AppointmentDate: new FormControl('', [Validators.required]),
      Designation: new FormControl('', [Validators.required]),
      CessationDate: new FormControl(''),
      // IsSection8: new FormControl('', []),
      PAN: new FormControl('', []),
      ShareHolding: new FormControl('', []),
      DormantCompany: new FormControl('', []),
      OtherCompany: new FormControl('', []),
      OtherNatureOfIntrest: new FormControl('', []),
      CommitteeType: new FormControl('', []),
      OtherCommittee: new FormControl('', []),
    });

    this.subDirectorForm = new FormGroup({
      CompanyName: new FormControl('', [Validators.required]),
      NumberOfSecurities: new FormControl('', [Validators.required]),
      SecurityDescription: new FormControl('', [Validators.required]),
      SecurityNominalValue: new FormControl('', []),
      AcquisitionDate: new FormControl('', [Validators.required]),
      AcquisitionPaidPrize: new FormControl('', []),
      AcquisitionOtherPrize: new FormControl('', []),
      DisposalDate: new FormControl(''),
      NumberOfSharesDisposed: new FormControl('', []),
      DisposalPrize: new FormControl('', []),
      DisposalReceivedPrize: new FormControl('', []),
      CumulativePrize: new FormControl('', []),
      AcquisitionSecuritiesMode: new FormControl('', []),
      HoldingMode: new FormControl('', []),
      PledgedSecurities: new FormControl('', []),
      Shareholding: new FormControl('', [])
    });

    this.relativesForm = new FormGroup({
      RelativeName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      Relationship: new FormControl('', [Validators.required]),
      RelativePAN: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      KmpPAN: new FormControl('', []),
      FirmName: new FormControl('', []),
      CompanyPAN: new FormControl('', []),
      FirmType: new FormControl('', []),
      NatureOfIntrest: new FormControl('', []),
      CIN: new FormControl('', [Validators.pattern("^([a-zA-Z]){1}([0-9]){5}([a-zA-Z]){2}([0-9]){4}([a-zA-Z]){3}([0-9]){6}?$")]),
      DormantCompany: new FormControl('', []),
      IntrestDate: new FormControl(''),
      IntrestChange: new FormControl(''),
      IntrestChangeDate: new FormControl(''),
      Shareholding: new FormControl('', []),
      OtherCompanyForRelative: new FormControl('', []),
      OtherNatureOfIntrestForRelative: new FormControl('', []),
      CommitteeType: new FormControl('', []),
      OtherCommittee: new FormControl('', []),
    });
    localStorage.removeItem('DirectorID');
    this.activatedRoute.params.subscribe(params => {
      console.log(params)
      if (params['directorId'] != undefined) {

        //validate User For permission.

        var data = {
          module: 'Director',
          ID: params['directorId'],
          CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
        }


        this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
      console.log('meetingAccess',meetingAccess)

          if (meetingAccess.status == 0) {

            $("#saveUpdateDirector").html('<i class="fa fa-save"></i>Update');
            localStorage.setItem('updateDirectorId', params['directorId']);
            this.loadDirectorDetails(params['directorId']);
            $('#breadCrumbAddDirectorTitle, #pageTitle').html("Director Details");
            this.preAppointmentsDateArray = new Array();
            if (this.preAppointmentsDateArray[0] == null) {
              this.preAppointmentsDateArray.splice(0, 1);
            }
          } else {

            this.authAlert.validateModuleWithPermissions('Director', params['directorId'], meetingAccess.companyID, 'edit')

          }

        })


      }
      else {
        this.KMPIsAvailable = false;
        this.availableKMPID = null;
        localStorage.removeItem('updateDirectorId');
        localStorage.removeItem('professionalDetailId');
        localStorage.removeItem('contactDetailId');
        $("#saveUpdateDirector").html('<i class="fa fa-save"></i>Save');
        $("#saveUpdateDirectorProfessionalDetails").html('<i class="fa fa-save"></i>Save');
        $("#saveUpdateDirectorContactDetails").html('<i class="fa fa-save"></i>Save');
        $('#breadCrumbAddDirectorTitle, #pageTitle').html("Add New Director");
      }
    });
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    this.TodayDate = { year: year, month: month, day: day };
  }

  private buildDtOptions1(url: string): DataTables.Settings {
    return {
      ajax: url,
      columns: [{
        title: 'Names of the Companies / bodies corporate / firms / association of individuals',
        data: 'OfficeName'
      }, {
        title: 'First name',
        data: 'firstName'
      }, {
        title: 'Last name',
        data: 'lastName'
      }]
    };
  }

  public noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }
  showMarridYesClick() {

    this.showMarridYes = true;
  }
  back() { 
this.router.navigate(
  [{ outlets: { 'structure-outlet': ['director']  } }],
  { relativeTo: this.activatedRoute.parent });
    // this.location.back(); 
  }
  getInCorpDate() {
    this.dateOfIncorpOfCompany = "";
    this.committeeService.getInCorpDateOfCompany().subscribe(companyDateOfIncorp => {
      console.log('ghgh',companyDateOfIncorp)

      let dt = new Date(this.commonFunction.setFormatDate(companyDateOfIncorp.CompanyDetails[0].DateOfIncorporation))
      this.dateOfIncorpOfCompany = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      // console.log('companyDateOfIncorpcompanyDateOfIncorp--------------------------->>>>',this.dateOfIncorpOfCompany);
      // let dt1 = new Date();
      // this.futureDate = { month: dt1.getMonth() + 1, day: dt1.getDate(), year: dt1.getFullYear() }
    })
  }

  hideMarridYesClick() {

    this.showMarridYes = false;
  }

  setControls() {
    this.directorProfessionalDetailsForm.controls.IsExecutive.setValue('false');
    this.directorMasterForm.controls.IsMarried.setValue('true');
    this.directorProfessionalDetailsForm.controls.IsChairman.setValue('false');
    this.directorProfessionalDetailsForm.controls.IsRetiringDirector.setValue('false');
    // this.directorMasterForm.controls.Gender.setValue('Male');
    this.directorMasterForm.controls.Resident.setValue('true');
    this.showMarridYesClick();
    this.directorContactDetailsForm.controls.PromoterGroupDirector.setValue('false');
    this.directorContactDetailsForm.controls.IsSittingFeesEligible.setValue('false');
    this.directorContactDetailsForm.controls.isAddressSame.setValue('false');
  }

  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setPreappointmentDate(date) {
    if (date != "" && date != null) {
      return date.day + "-" + date.month + "-" + date.year;
    }
    return null;
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
      //.toLocaleDateString();
    }
    return null;
  }

  PersonalDetailsInsertUpdate() {
    if (localStorage.getItem('updateDirectorId') != undefined) {

      this.updateDirector();

    }
    else {
      this.addDirector();
    }
  }

  generateOutput() {
    var object = {
      id: localStorage.getItem('updateDirectorId'),
      fromDate: this.FromDateModelInDirectorship,
      toDate: this.ToDateModelInDirectorship,
      date1: this.FromDateModelInSubDirector,
      date2: this.ToDateModelInSubDirector
    }
    this.DirectorMasterService.generateDirectorDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(localStorage.getItem('updateDirectorId'));
          setTimeout(function () {
            self.downloadPdfDocument(localStorage.getItem('updateDirectorId'));
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.DirectorMasterService.downloadDirectorFile(id);
  }
  downloadPdfDocument(id) {
    this.DirectorMasterService.downloadDirectorPdfFile(id);
  }

  generateMbp4bDocument() {
    this.DirectorMasterService.generateMbp4bDocument(localStorage.getItem('updateDirectorId')).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        this.downloadMbp4BDocument(localStorage.getItem('updateDirectorId'));
        this.downloadMbp4BPdfDocument(localStorage.getItem('updateDirectorId'));
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadMbp4BDocument(id) {
    this.DirectorMasterService.downloadMbp4bFile(id);
  }
  downloadMbp4BPdfDocument(id) {
    this.DirectorMasterService.downloadMbp4bPdfFile(id);
  }

  professionalDetailsInsertUpdate() {
    if (localStorage.getItem('updateDirectorId') != undefined && localStorage.getItem('professionalDetailId') != undefined) {
      this.updateProfessionalDetails();
    }
    else {
      this.addProfessionalDetails();
    }
  }

  contactdetailsInsertUpdate() {
    if (localStorage.getItem('updateDirectorId') != undefined && localStorage.getItem('contactDetailId') != undefined) {
      this.updateContactDetails();
    }
    else {
      this.addContactDetails();
    }
  }



  //add master director details
  addDirector() {
    if (this.directorMasterForm.status == "VALID") {
      var newDirector = {
        "Director":
        {
          Din: this.directorMasterForm.controls.Din.value.trim(),
          FirstName: this.directorMasterForm.controls.FirstName.value.trim(),
          MiddleName: this.directorMasterForm.controls.MiddleName.value.trim(),
          LastName: this.directorMasterForm.controls.LastName.value.trim(),
          FatherFirstName: this.directorMasterForm.controls.FatherFirstName.value.trim(),
          FatherMiddleName: this.directorMasterForm.controls.FatherMiddleName.value.trim(),
          FatherLastName: this.directorMasterForm.controls.FatherLastName.value.trim(),
          MotherFirstName: this.directorMasterForm.controls.MotherFirstName.value.trim(),
          MotherMiddleName: this.directorMasterForm.controls.MotherMiddleName.value.trim(),
          MotherLastName: this.directorMasterForm.controls.MotherLastName.value.trim(),
          DateOfBirth: this.setDate(this.directorMasterForm.controls.DateOfBirth.value),
          BirthPlace: this.directorMasterForm.controls.BirthPlace.value.trim(),
          Gender: this.directorMasterForm.controls.Gender.value,
          Nationality: this.directorMasterForm.controls.Nationality.value,
          Resident: this.directorMasterForm.controls.Resident.value,
          Occupation: this.directorMasterForm.controls.Occupation.value.trim(),
          EducationalQualification: this.directorMasterForm.controls.EducationalQualification.value.trim(),
          //IsChairman: this.directorMasterForm.controls.IsChairman.value,
          PAN: this.directorMasterForm.controls.PAN.value.toUpperCase(),
          EmailID: this.directorMasterForm.controls.EmailID.value,
          IsMarried: this.directorMasterForm.controls.IsMarried.value,
          SpouseFirstName: this.directorMasterForm.controls.SpouseFirstName.value.trim(),
          SpouseMiddleName: this.directorMasterForm.controls.SpouseMiddleName.value.trim(),
          SpouseLastName: this.directorMasterForm.controls.SpouseLastName.value.trim(),
          directorAsKMP: {
            "isAvailable": this.isKmp,
            "kmpID": ""
          }
        }
      }

      console.log(newDirector);

      this.DirectorMasterService.addDirector(newDirector)
        .subscribe(director => {
          if (director.status == 0) {
             
            this.alert.successWithOk("Director details saved successfully.", '/director/edit/' + director.directorResult[0]._id);
            // localStorage.setItem('DirectorID', director.directorResult[0]._id);
            // this.loadDirectorDetails(director.directorResult[0]._id);
            // this.router.navigate(['/director/edit/' + director.directorResult[0]._id]);
          }
          else {
            this.alert.error(director.message);
          }
        });
    }
  }

  clearDirector() {
    this.directorMasterForm.controls.Din.setValue('');
    this.directorMasterForm.controls.FirstName.setValue('');
    this.directorMasterForm.controls.MiddleName.setValue('');
    this.directorMasterForm.controls.LastName.setValue('');
    this.directorMasterForm.controls.FatherFirstName.setValue('');
    this.directorMasterForm.controls.FatherMiddleName.setValue('');
    this.directorMasterForm.controls.FatherLastName.setValue('');
    this.directorMasterForm.controls.MotherFirstName.setValue('');
    this.directorMasterForm.controls.MotherMiddleName.setValue('');
    this.directorMasterForm.controls.MotherLastName.setValue('');
    this.directorMasterForm.controls.DateOfBirth.setValue(null);
    this.directorMasterForm.controls.BirthPlace.setValue('');
    this.directorMasterForm.controls.Occupation.setValue('');
    this.directorMasterForm.controls.Nationality.setValue(null);
    this.directorMasterForm.controls.EducationalQualification.setValue('');
    this.directorMasterForm.controls.PAN.setValue('');
    this.directorMasterForm.controls.IsMarried.setValue('true');
    // this.directorMasterForm.controls.Gender.setValue('Male');
    this.directorMasterForm.controls.Resident.setValue('true');
    this.directorMasterForm.controls.SpouseFirstName.setValue('');
    this.directorMasterForm.controls.SpouseMiddleName.setValue('');
    this.directorMasterForm.controls.SpouseLastName.setValue('');
    this.directorMasterForm.controls.EmailID.setValue('');
    $('#personalConfirmation').modal('toggle');
  }

  updateDirector() {
    if (this.directorMasterForm.status == "VALID") {
       
      var updateDirector = {
        "Director":
        {
          _id: localStorage.getItem('updateDirectorId'),
          CompanyID: null,
          Din: this.directorMasterForm.controls.Din.value,
          FirstName: this.directorMasterForm.controls.FirstName.value.trim(),
          MiddleName: this.directorMasterForm.controls.MiddleName.value.trim(),
          LastName: this.directorMasterForm.controls.LastName.value.trim(),
          FatherFirstName: this.directorMasterForm.controls.FatherFirstName.value.trim(),
          FatherMiddleName: this.directorMasterForm.controls.FatherMiddleName.value.trim(),
          FatherLastName: this.directorMasterForm.controls.FatherLastName.value.trim(),
          MotherFirstName: this.directorMasterForm.controls.MotherFirstName.value.trim(),
          MotherMiddleName: this.directorMasterForm.controls.MotherMiddleName.value.trim(),
          MotherLastName: this.directorMasterForm.controls.MotherLastName.value.trim(),
          DateOfBirth: this.setDate(this.directorMasterForm.controls.DateOfBirth.value),
          BirthPlace: this.directorMasterForm.controls.BirthPlace.value.trim(),
          Gender: this.directorMasterForm.controls.Gender.value,
          Nationality: this.directorMasterForm.controls.Nationality.value,
          Resident: this.directorMasterForm.controls.Resident.value,
          Occupation: this.directorMasterForm.controls.Occupation.value.trim(),
          EducationalQualification: this.directorMasterForm.controls.EducationalQualification.value.trim(),
          PAN: this.directorMasterForm.controls.PAN.value.toUpperCase(),
          EmailID: this.directorMasterForm.controls.EmailID.value,
          IsMarried: this.directorMasterForm.controls.IsMarried.value,
          SpouseFirstName: this.directorMasterForm.controls.SpouseFirstName.value.trim(),
          SpouseMiddleName: this.directorMasterForm.controls.SpouseMiddleName.value.trim(),
          SpouseLastName: this.directorMasterForm.controls.SpouseLastName.value.trim(),
          ModifiedBy: null,
          ModifiedDate: this.setDate(new Date())
        }
      }
      console.log('updateDirector', updateDirector);
      this.DirectorMasterService.addDirector(updateDirector)
        .subscribe(director => {
          if (director.status == 0) {
             
            this.alert.success("Director Personal details updated successfully.");
          }
          else {
            this.alert.error(director.message);
          }
        });
    }
  }
  //add director professional details
  addProfessionalDetails() {
     
    if (this.directorProfessionalDetailsForm.status == "VALID") {
      var varagendaCompliance = $('.select2').val();
      var newdirectorID = "";
      if (localStorage.getItem('DirectorID') != undefined) {
        newdirectorID = localStorage.getItem('DirectorID');
      }
      else if (localStorage.getItem('updateDirectorId') != undefined) {
        newdirectorID = localStorage.getItem('updateDirectorId');
      }
      if (newdirectorID == "") {
        this.alert.error("Please first insert Personal Director details.");
        return false;
      }
      var newDirectorProfessionalDetails = {
        "ProfessionalDetails":
        {
          DirectorID: newdirectorID,
          IsExecutive: this.directorProfessionalDetailsForm.controls.IsExecutive.value,
          IsRetiringDirector: this.directorProfessionalDetailsForm.controls.IsRetiringDirector.value,
          Designation: this.directorProfessionalDetailsForm.controls.Designation.value,
          Category: this.directorProfessionalDetailsForm.controls.Category.value,
          BoardResolutionDate: this.setDate(this.directorProfessionalDetailsForm.controls.BoardResolutionDate.value),
          AppointmentDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentDate.value),
          AppointmentDIR12FillingDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentDIR12FillingDate.value),
          ReAppointmentDate: this.setDate(this.directorProfessionalDetailsForm.controls.ReAppointmentDate.value),
          CessationDate: this.setDate(this.directorProfessionalDetailsForm.controls.CessationDate.value),
          PreAppointmentDates: JSON.stringify(this.datesSelected),//this.setDate(this.directorProfessionalDetailsForm.controls.PreAppointmentDates.value),
          ResignationDIR11filingDate: this.setDate(this.directorProfessionalDetailsForm.controls.ResignationDIR11filingDate.value),
          CessationType: this.directorProfessionalDetailsForm.controls.CessationType.value,
          CessationReason: this.directorProfessionalDetailsForm.controls.CessationReason.value.trim(),
          AppointmentCompletionDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentCompletionDate.value),
          DisqualificationDate: this.setDate(this.directorProfessionalDetailsForm.controls.DisqualificationDate.value),
          RemovalDIR12FilingDate: this.setDate(this.directorProfessionalDetailsForm.controls.RemovalDIR12FilingDate.value),
          DisqualificationDetails: this.directorProfessionalDetailsForm.controls.DisqualificationDetails.value.trim(),
          RemovalDate: this.setDate(this.directorProfessionalDetailsForm.controls.RemovalDate.value),
          NoticeReceivedDate: this.setDate(this.directorProfessionalDetailsForm.controls.NoticeReceivedDate.value),
          ResignationEffectiveDate: this.setDate(this.directorProfessionalDetailsForm.controls.ResignationEffectiveDate.value),
          IsChairman: this.directorProfessionalDetailsForm.controls.IsChairman.value,
          OtherCessationType: this.directorProfessionalDetailsForm.controls.OtherCessationType.value,

          FunctionalAreas: this.directorProfessionalDetailsForm.controls.FunctionalAreas.value.trim(),
          DesignationDIR12FillingDate: this.setDate(this.directorProfessionalDetailsForm.controls.DesignationDIR12FillingDate.value),
          PromoterGroupDirector: this.directorProfessionalDetailsForm.controls.PromoterGroupDirector.value,
          IsSittingFeesEligible: this.directorProfessionalDetailsForm.controls.IsSittingFeesEligible.value,
          AllMeetingSittingFees: this.directorProfessionalDetailsForm.controls.AllMeetingSittingFees.value,
          MeetingAttendedNumber: this.directorProfessionalDetailsForm.controls.MeetingAttendedNumber.value,//.trim(),
          Commission: this.directorProfessionalDetailsForm.controls.Commission.value,//.trim(),
          Remuneration: this.directorProfessionalDetailsForm.controls.Remuneration.value,//.trim(),
          DSCSigningDate: this.setDate(this.directorProfessionalDetailsForm.controls.DSCSigningDate.value),
          DisqualifiedDirector: this.directorProfessionalDetailsForm.controls.DisqualifiedDirector.value

        }
      }
      this.DirectorMasterService.addDirector(newDirectorProfessionalDetails)
        .subscribe(directorProfession => {
          if (directorProfession.status == 0) {
             
            this.alert.success("Director professional details saved successfully.");
          }
          else {
            this.alert.error(directorProfession.message);
          }
        });
    }
  }

  clearProfessionalDetails() {
    this.directorProfessionalDetailsForm.controls.BoardResolutionDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.AppointmentDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.AppointmentDIR12FillingDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.ReAppointmentDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.PreAppointmentDates.setValue(null);
    this.directorProfessionalDetailsForm.controls.CessationDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.ResignationDIR11filingDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.CessationReason.setValue('');
    this.directorProfessionalDetailsForm.controls.AppointmentCompletionDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.DisqualificationDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.DisqualificationDetails.setValue('');
    this.directorProfessionalDetailsForm.controls.RemovalDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.NoticeReceivedDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.RemovalDIR12FilingDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.ResignationEffectiveDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.Designation.setValue('');
    this.directorProfessionalDetailsForm.controls.Category.setValue('');
    this.directorProfessionalDetailsForm.controls.IsChairman.setValue('false');
    this.directorProfessionalDetailsForm.controls.CessationType.setValue(null);
    this.cessationDateIsPrior = false;
    this.preAppointmentsDateArray = [];


    this.directorProfessionalDetailsForm.controls.FunctionalAreas.setValue('');
    this.directorProfessionalDetailsForm.controls.DesignationDIR12FillingDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.AllMeetingSittingFees.setValue('');
    this.directorProfessionalDetailsForm.controls.MeetingAttendedNumber.setValue('');
    this.directorProfessionalDetailsForm.controls.Commission.setValue('');
    this.directorProfessionalDetailsForm.controls.Remuneration.setValue('');
    this.directorProfessionalDetailsForm.controls.DSCSigningDate.setValue(null);
    this.directorProfessionalDetailsForm.controls.DisqualifiedDirector.setValue('');
    this.directorProfessionalDetailsForm.controls.PromoterGroupDirector.setValue('false');
    this.directorProfessionalDetailsForm.controls.IsSittingFeesEligible.setValue('false');
    this.datesSelected = [];
    $("#professionalConfirmation").modal('toggle');
  }


  //update professional details
  updateProfessionalDetails() {

    // if (this.directorProfessionalDetailsForm.status == "VALID") {
     
    var varagendaCompliance = $('.select2').val();
    var updateDirectorProfessionalDetails = {
      "ProfessionalDetails":
      {
        _id: localStorage.getItem('professionalDetailId'),
        DirectorID: localStorage.getItem('updateDirectorId'),
        IsExecutive: this.directorProfessionalDetailsForm.controls.IsExecutive.value,
        IsRetiringDirector: this.directorProfessionalDetailsForm.controls.IsRetiringDirector.value,
        Designation: this.directorProfessionalDetailsForm.controls.Designation.value,
        Category: this.directorProfessionalDetailsForm.controls.Category.value,
        BoardResolutionDate: this.setDate(this.directorProfessionalDetailsForm.controls.BoardResolutionDate.value),
        AppointmentDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentDate.value),
        AppointmentDIR12FillingDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentDIR12FillingDate.value),
        PreAppointmentDates: JSON.stringify(this.datesSelected),//this.setDate(this.directorProfessionalDetailsForm.controls.PreAppointmentDates.value),
        ReAppointmentDate: this.setDate(this.directorProfessionalDetailsForm.controls.ReAppointmentDate.value),
        CessationDate: this.setDate(this.directorProfessionalDetailsForm.controls.CessationDate.value),
        ResignationDIR11filingDate: this.setDate(this.directorProfessionalDetailsForm.controls.ResignationDIR11filingDate.value),
        CessationType: this.directorProfessionalDetailsForm.controls.CessationType.value,
        CessationReason: this.directorProfessionalDetailsForm.controls.CessationReason.value.trim(),
        AppointmentCompletionDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentCompletionDate.value),
        DisqualificationDate: this.setDate(this.directorProfessionalDetailsForm.controls.DisqualificationDate.value),
        DisqualificationDetails: this.directorProfessionalDetailsForm.controls.DisqualificationDetails.value.trim(),
        RemovalDIR12FilingDate: this.setDate(this.directorProfessionalDetailsForm.controls.RemovalDIR12FilingDate.value),
        RemovalDate: this.setDate(this.directorProfessionalDetailsForm.controls.RemovalDate.value),
        NoticeReceivedDate: this.setDate(this.directorProfessionalDetailsForm.controls.NoticeReceivedDate.value),
        ResignationEffectiveDate: this.setDate(this.directorProfessionalDetailsForm.controls.ResignationEffectiveDate.value),
        IsChairman: this.directorProfessionalDetailsForm.controls.IsChairman.value,
        OtherCessationType: this.directorProfessionalDetailsForm.controls.OtherCessationType.value,

        FunctionalAreas: this.directorProfessionalDetailsForm.controls.FunctionalAreas.value.trim(),
        DesignationDIR12FillingDate: this.setDate(this.directorProfessionalDetailsForm.controls.DesignationDIR12FillingDate.value),
        PromoterGroupDirector: this.directorProfessionalDetailsForm.controls.PromoterGroupDirector.value,
        IsSittingFeesEligible: this.directorProfessionalDetailsForm.controls.IsSittingFeesEligible.value,
        AllMeetingSittingFees: this.directorProfessionalDetailsForm.controls.AllMeetingSittingFees.value,
        MeetingAttendedNumber: this.directorProfessionalDetailsForm.controls.MeetingAttendedNumber.value,
        Commission: this.directorProfessionalDetailsForm.controls.Commission.value,
        Remuneration: this.directorProfessionalDetailsForm.controls.Remuneration.value,
        DSCSigningDate: this.setDate(this.directorProfessionalDetailsForm.controls.DSCSigningDate.value),
        DisqualifiedDirector: this.directorProfessionalDetailsForm.controls.DisqualifiedDirector.value,

        ModifiedBy: null,
        ModifiedDate: this.setDate(new Date())
      }
    }
    this.DirectorMasterService.addDirector(updateDirectorProfessionalDetails)
      .subscribe(director => {
        if (director.status == 0) {
           
          this.alert.success("Director professional details updated successfully.");
        }

        else if (director.status == 1 && director.message == 'Company already have One Chairman and cannot appoint more than one') {
          this.alert.error(director.message);
          this.directorProfessionalDetailsForm.controls.IsChairman.setValue('false');
        }
        else {
          this.alert.error(director.message);
        }
      });
    // }
  }
  //add director contact details
  addContactDetails() {
     
    if (this.directorContactDetailsForm.status == "VALID") {
       
      var newdirectorID = "";
      if (localStorage.getItem('DirectorID') != undefined) {
        newdirectorID = localStorage.getItem('DirectorID');
      }
      else if (localStorage.getItem('updateDirectorId') != undefined) {
        newdirectorID = localStorage.getItem('updateDirectorId');
      }
      if (newdirectorID == "") {
        this.alert.error("Please first insert Personal Director details.");
        return false;
      }
      var newContactDetails = {
        "ContactDetails":
        {
          DirectorID: newdirectorID,
          PermenantResidentialAddress: {
            PinCode: this.PermenantResidentialAddress.controls.PinCode.value.trim(),
            City: this.PermenantResidentialAddress.controls.City.value.trim(),
            State: this.PermenantResidentialAddress.controls.State.value,
            Country: this.PermenantResidentialAddress.controls.Country.value,
            Line2: this.PermenantResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PermenantResidentialAddress.controls.Line1.value.trim()
          },
          PresentResidentialAddress: {
            PinCode: this.PresentResidentialAddress.controls.PinCode.value.trim(),
            City: this.PresentResidentialAddress.controls.City.value.trim(),
            State: this.PresentResidentialAddress.controls.State.value,
            Country: this.PresentResidentialAddress.controls.Country.value,
            Line2: this.PresentResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PresentResidentialAddress.controls.Line1.value.trim()
          },
          OfficeAddress: {
            PinCode: this.OfficeAddress.controls.PinCode.value.trim(),
            City: this.OfficeAddress.controls.City.value.trim(),
            State: this.OfficeAddress.controls.State.value,
            Country: this.OfficeAddress.controls.Country.value,
            Line2: this.OfficeAddress.controls.Line2.value.trim(),
            Line1: this.OfficeAddress.controls.Line1.value.trim()
          },
          OfficeTelephoneNumber: this.directorContactDetailsForm.controls.OfficeTelephoneNumber.value,
          ResidentTelephoneNumber: this.directorContactDetailsForm.controls.ResidentTelephoneNumber.value,
          Fax: this.directorContactDetailsForm.controls.Fax.value,
          MobileNumber: this.directorContactDetailsForm.controls.MobileNumber.value,
          AadhaarNumber: this.directorContactDetailsForm.controls.AadhaarNumber.value.trim(),
          IdentityNumber: this.directorContactDetailsForm.controls.IdentityNumber.value.trim(),
          PassportNumber: this.directorContactDetailsForm.controls.PassportNumber.value.trim(),
          DrivingLicenseNumber: this.directorContactDetailsForm.controls.DrivingLicenseNumber.value.trim(),
          // FunctionalAreas: this.directorContactDetailsForm.controls.FunctionalAreas.value.trim(),
          // DesignationDIR12FillingDate: this.setDate(this.directorContactDetailsForm.controls.DesignationDIR12FillingDate.value),
          // PromoterGroupDirector: this.directorContactDetailsForm.controls.PromoterGroupDirector.value,
          // IsSittingFeesEligible: this.directorContactDetailsForm.controls.IsSittingFeesEligible.value,
          // AllMeetingSittingFees: this.directorContactDetailsForm.controls.AllMeetingSittingFees.value,
          // MeetingAttendedNumber: this.directorContactDetailsForm.controls.MeetingAttendedNumber.value,//.trim(),
          // Commission: this.directorContactDetailsForm.controls.Commission.value,//.trim(),
          // Remuneration: this.directorContactDetailsForm.controls.Remuneration.value,//.trim(),
          // DSCSigningDate: this.setDate(this.directorContactDetailsForm.controls.DSCSigningDate.value),
          // DisqualifiedDirector: this.directorContactDetailsForm.controls.DisqualifiedDirector.value
        }
      }
      this.DirectorMasterService.addDirector(newContactDetails)
        .subscribe(directorContact => {
          if (directorContact.status == 0) {
             
            this.alert.success("Director contact details saved successfully.");
          }
          else {
            this.alert.error(directorContact.message);
          }
        });
    }
  }
  clearContactDetails() {
    this.PermenantResidentialAddress.controls.Line1.setValue('');
    this.PermenantResidentialAddress.controls.Line2.setValue('');
    this.PermenantResidentialAddress.controls.Country.setValue('');
    this.PermenantResidentialAddress.controls.State.setValue('');
    this.PermenantResidentialAddress.controls.City.setValue('');
    this.PermenantResidentialAddress.controls.PinCode.setValue('');
    this.PresentResidentialAddress.controls.Line1.setValue('');
    this.PresentResidentialAddress.controls.Line2.setValue('');
    this.PresentResidentialAddress.controls.Country.setValue('');
    this.PresentResidentialAddress.controls.State.setValue('');
    this.PresentResidentialAddress.controls.PinCode.setValue('');
    this.PresentResidentialAddress.controls.City.setValue('');
    this.OfficeAddress.controls.Line1.setValue('');
    this.OfficeAddress.controls.Line2.setValue('');
    this.OfficeAddress.controls.PinCode.setValue('');
    this.OfficeAddress.controls.Country.setValue('');
    this.OfficeAddress.controls.State.setValue('');
    this.OfficeAddress.controls.City.setValue('');
    this.directorContactDetailsForm.controls.OfficeTelephoneNumber.setValue('');
    this.directorContactDetailsForm.controls.ResidentTelephoneNumber.setValue('');
    this.directorContactDetailsForm.controls.Fax.setValue('');
    this.directorContactDetailsForm.controls.AadhaarNumber.setValue('');
    this.directorContactDetailsForm.controls.IdentityNumber.setValue('');
    this.directorContactDetailsForm.controls.PassportNumber.setValue('');
    this.directorContactDetailsForm.controls.DrivingLicenseNumber.setValue('');
    this.directorContactDetailsForm.controls.MobileNumber.setValue('');

    // this.directorContactDetailsForm.controls.FunctionalAreas.setValue('');
    // this.directorContactDetailsForm.controls.DesignationDIR12FillingDate.setValue(null);
    // this.directorContactDetailsForm.controls.AllMeetingSittingFees.setValue('');
    // this.directorContactDetailsForm.controls.MeetingAttendedNumber.setValue('');
    // this.directorContactDetailsForm.controls.Commission.setValue('');
    // this.directorContactDetailsForm.controls.Remuneration.setValue('');
    // this.directorContactDetailsForm.controls.DSCSigningDate.setValue(null);
    // this.directorContactDetailsForm.controls.DisqualifiedDirector.setValue('');
    // this.directorContactDetailsForm.controls.PromoterGroupDirector.setValue('false');
    // this.directorContactDetailsForm.controls.IsSittingFeesEligible.setValue('false');
    $("#contactConfirmation").modal('toggle');
  }
  //update contact details
  updateContactDetails() {
    if (this.directorContactDetailsForm.status == "VALID") {
       //professionalDetailId
      var updateContactDetails = {
        "ContactDetails":
        {
          _id: localStorage.getItem('contactDetailId'),
          DirectorID: localStorage.getItem('updateDirectorId'),
          PermenantResidentialAddress: {
            PinCode: this.PermenantResidentialAddress.controls.PinCode.value.trim(),
            City: this.PermenantResidentialAddress.controls.City.value.trim(),
            State: this.PermenantResidentialAddress.controls.State.value,
            Country: this.PermenantResidentialAddress.controls.Country.value,
            Line2: this.PermenantResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PermenantResidentialAddress.controls.Line1.value.trim()
          },
          PresentResidentialAddress: {
            PinCode: this.PresentResidentialAddress.controls.PinCode.value.trim(),
            City: this.PresentResidentialAddress.controls.City.value.trim(),
            State: this.PresentResidentialAddress.controls.State.value,
            Country: this.PresentResidentialAddress.controls.Country.value,
            Line2: this.PresentResidentialAddress.controls.Line2.value.trim(),
            Line1: this.PresentResidentialAddress.controls.Line1.value.trim()
          },
          OfficeAddress: {
            PinCode: this.OfficeAddress.controls.PinCode.value.trim(),
            City: this.OfficeAddress.controls.City.value.trim(),
            State: this.OfficeAddress.controls.State.value,
            Country: this.OfficeAddress.controls.Country.value,
            Line2: this.OfficeAddress.controls.Line2.value.trim(),
            Line1: this.OfficeAddress.controls.Line1.value.trim()
          },
          OfficeTelephoneNumber: this.directorContactDetailsForm.controls.OfficeTelephoneNumber.value,
          ResidentTelephoneNumber: this.directorContactDetailsForm.controls.ResidentTelephoneNumber.value,
          Fax: this.directorContactDetailsForm.controls.Fax.value,
          MobileNumber: this.directorContactDetailsForm.controls.MobileNumber.value,
          AadhaarNumber: this.directorContactDetailsForm.controls.AadhaarNumber.value.trim(),
          IdentityNumber: this.directorContactDetailsForm.controls.IdentityNumber.value.trim(),
          PassportNumber: this.directorContactDetailsForm.controls.PassportNumber.value.trim(),
          DrivingLicenseNumber: this.directorContactDetailsForm.controls.DrivingLicenseNumber.value.trim(),
          // FunctionalAreas: this.directorContactDetailsForm.controls.FunctionalAreas.value.trim(),
          // DesignationDIR12FillingDate: this.setDate(this.directorContactDetailsForm.controls.DesignationDIR12FillingDate.value),
          // PromoterGroupDirector: this.directorContactDetailsForm.controls.PromoterGroupDirector.value,
          // IsSittingFeesEligible: this.directorContactDetailsForm.controls.IsSittingFeesEligible.value,
          // AllMeetingSittingFees: this.directorContactDetailsForm.controls.AllMeetingSittingFees.value,
          // MeetingAttendedNumber: this.directorContactDetailsForm.controls.MeetingAttendedNumber.value,
          // Commission: this.directorContactDetailsForm.controls.Commission.value,
          // Remuneration: this.directorContactDetailsForm.controls.Remuneration.value,
          // DSCSigningDate: this.setDate(this.directorContactDetailsForm.controls.DSCSigningDate.value),
          // DisqualifiedDirector: this.directorContactDetailsForm.controls.DisqualifiedDirector.value,
          ModifiedBy: null,
          ModifiedDate: this.setDate(new Date())
        }
      }
      this.DirectorMasterService.addDirector(updateContactDetails)
        .subscribe(directorContact => {
          if (directorContact.status == 0) {
             
            this.alert.success("Director contact details updated successfully.");
          }
          else {
            this.alert.error(directorContact.message);
          }
        });
    }
  }

  directorshipInsertandUpdate() {
     
    // localStorage.getItem('updateDirectorId') != undefined 
    //&& localStorage.getItem('directorshipId') != undefined
    if (this.globalDirectorshipID != undefined) {
      this.updateDirectorship();
    }
    else {
      this.addDirectorship();
    }
  }


  addDirectorship() {
    if (this.directorshipForm.status == "VALID") {
       
      var directorID = "";
      if (localStorage.getItem('DirectorID') != undefined) {
        directorID = localStorage.getItem('DirectorID');
      }
      else if (localStorage.getItem('updateDirectorId') != undefined) {
        directorID = localStorage.getItem('updateDirectorId');
      }
      if (directorID == "") {
        $("#directorshipDialog").modal('toggle');
        this.alert.error("Please first insert Personal Director details.");
        return false;
      }
      console.log('directorMasterForm',this.directorMasterForm)
      var newdirectorship = {
        "Directorship": {
          DirectorID: directorID,
          OfficeName: this.directorshipForm.controls.OfficeName.value,
          OfficeType: this.directorshipForm.controls.OfficeType.value,
          CIN: this.directorshipForm.controls.CIN.value,
          AppointmentDate: this.setDate(this.directorshipForm.controls.AppointmentDate.value),
          Designation: this.directorshipForm.controls.Designation.value,
          CessationDate: this.setDate(this.directorshipForm.controls.CessationDate.value),
          PAN: this.directorshipForm.controls.PAN.value,
          ShareHolding: this.directorshipForm.controls.ShareHolding.value,
          DormantCompany: this.directorshipForm.controls.DormantCompany.value,
          OtherCompany: this.directorshipForm.controls.OtherCompany.value,
          OtherNatureOfIntrest: this.directorshipForm.controls.OtherNatureOfIntrest.value,
          CommitteeType: this.directorshipForm.controls.CommitteeType.value,
          OtherCommittee: this.directorshipForm.controls.OtherCommittee.value,
        }
      }

      this.DirectorMasterService.addDirector(newdirectorship)
        .subscribe(directorship => {
          if (directorship.status == 0) {
             
            $("#directorshipDialog").modal('toggle');
            this.alert.success("Directorship details saved successfully.");
            this.loadDirectorshipDetails(directorID);
            this.clearDirectorship();
          }
          else {
            $("#directorshipDialog").modal('toggle');
            this.alert.error(directorship.message);
          }
        });
    }
  }

  removeDirectorship() {
     
    this.DirectorMasterService.removeDirectorship(this.deleteDirectorshipID)
      .subscribe((directorshipRemove:any) => {
        if (directorshipRemove.status == 0) {
           
          this.alert.success("Directorship details deleted successfully.");
          this.clearDirectorship();
          if (localStorage.getItem('DirectorID') != undefined) {
            this.loadDirectorshipDetails(localStorage.getItem('DirectorID'));
          }
          else if (localStorage.getItem('updateDirectorId') != undefined) {
            this.loadDirectorshipDetails(localStorage.getItem('updateDirectorId'));
          }
          $("#deletedirectorshipconfirmation").modal('toggle');
        }
        else {
          this.alert.success(directorshipRemove.message);
        }
      });
  }

  CommitteeTypeModel: any;

  fetchDirectorshipRow(i) {
     
    let dt;
    $('#myModalOfficeHeldOrRelinquishedLabel').html('<i class="fa fa-pencil"></i>Edit Offices held or relinquished :');
    $("#inputdirectorshipOfficeName").focus();
    $("#btnaddDirectorshipRow").html('<i class="fa fa-save"></i>Update');
    //localStorage.setItem('directorshipId', this.directorshipArray[i]._id);
    this.globalDirectorshipID = this.directorshipArray[i]._id;
    this.directorshipForm.controls['OfficeName'].setValue(this.directorshipArray[i].OfficeName);
    this.directorshipForm.controls['CIN'].setValue(this.directorshipArray[i].CIN);
    if (this.directorshipArray[i].OfficeType != null) {
      var event = {
        target: {
          value: this.directorshipArray[i].OfficeType
        }
      };
      this.setdormantCompany(event);
      this.setCIN(event);
      this.setOtherCompany(event);
      this.setNatureOfIntrest(event);
      this.directorshipForm.controls.OfficeType.setValue(this.directorshipArray[i].OfficeType);
    }
    else {
      this.directorshipForm.controls.OfficeType.setValue(null);
    }
    this.directorshipForm.controls.Designation.setValue(this.directorshipArray[i].Designation);
    if (this.directorshipArray[i].Designation == "Member") {
      this.showShareHolding = true;
      this.directorshipForm.controls.ShareHolding.setValue(this.directorshipArray[i].ShareHolding);
    }
    else {
      this.showShareHolding = false;
      this.directorshipForm.controls.ShareHolding.setValue(null);
    }
    if (this.directorshipArray[i].Designation == "Committee Member" || this.directorshipArray[i].Designation == "Committee Chairman") {
      this.showCommitee = true;
      this.showOtherCommitee = false;
      this.CommitteeTypeModel = this.directorshipArray[i].CommitteeType;
      this.directorshipForm.controls.CommitteeType.setValue(this.directorshipArray[i].CommitteeType);
      if (this.directorshipArray[i].CommitteeType == "Others") {
        this.showOtherCommitee = true;
        this.directorshipForm.controls.OtherCommittee.setValue(this.directorshipArray[i].OtherCommittee);
      }
      else {
        this.showOtherCommitee = false;
      }
    }
    else {
      this.showCommitee = false;
      this.directorshipForm.controls.CommitteeType.setValue(null);
    }

    if (this.directorshipArray[i].Designation == "Others") {
      this.showOtherNatureOfIntrest = true;
      this.directorshipForm.controls.OtherNatureOfIntrest.setValue(this.directorshipArray[i].OtherNatureOfIntrest);
    }
    else {
      this.showOtherNatureOfIntrest = false;
      this.directorshipForm.controls.OtherNatureOfIntrest.setValue(null);
    }



    if (this.directorshipArray[i].AppointmentDate != null) {
      dt = new Date(this.setFormatDate(this.directorshipArray[i].AppointmentDate));
      this.dirAppointmentDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.directorshipForm.controls['AppointmentDate'].setValue(this.dirAppointmentDateModel);
    }
    else {
      this.directorshipForm.controls['AppointmentDate'].setValue(null);
    }
    if (this.directorshipArray[i].CessationDate != null) {
      dt = new Date(this.setFormatDate(this.directorshipArray[i].CessationDate));
      this.dirCessationDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.directorshipForm.controls['CessationDate'].setValue(this.dirCessationDateModel);
    }
    else {
      this.directorshipForm.controls['CessationDate'].setValue(null);
    }
    this.directorshipForm.controls.PAN.setValue(this.directorshipArray[i].PAN);
    if (this.directorshipArray[i].OfficeType == "OPC" || this.directorshipArray[i].OfficeType == "Public Unlisted Company" || this.directorshipArray[i].OfficeType == "Private Limited Company") {
      this.showDormantState = true;
      if (this.directorshipArray[i].DormantCompany != null && this.directorshipArray[i].DormantCompany == true) {
        this.directorshipForm.controls.DormantCompany.setValue('true');
      }
      else {
        this.directorshipForm.controls.DormantCompany.setValue('false');
      }
    }
    else {
      this.showDormantState = false;
    }
    if (this.directorshipArray[i].OfficeType == "Private Debt Listed Company" || this.directorshipArray[i].OfficeType == "Private Limited Company"
      || this.directorshipArray[i].OfficeType == "Public Listed Company" || this.directorshipArray[i].OfficeType == "Public Unlisted Company" || this.directorshipArray[i].OfficeType == "Section 8 Company" ||
      this.directorshipArray[i].OfficeType == "OPC" || this.directorshipArray[i].OfficeType == "Foreign Company") {
      this.showCIN = true;
      this.directorshipForm.controls.CIN.setValue(this.directorshipArray[i].CIN);
    }
    else {
      this.showCIN = false;
      this.directorshipForm.controls.CIN.setValue(null);
    }
    if (this.directorshipArray[i].OfficeType == "Others") {
      this.showOtherCompany = true;
      this.directorshipForm.controls.OtherCompany.setValue(this.directorshipArray[i].OtherCompany);
    }
    else {
      this.showOtherCompany = false;
      this.directorshipForm.controls.OtherCompany.setValue(null);
    }
  }

  updateDirectorship() {
     
    var directorID = "";
    if (localStorage.getItem('DirectorID') != undefined) {
      directorID = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorID = localStorage.getItem('updateDirectorId');
    }
    var updateDirectorshipData = {
      "Directorship": {
        _id: this.globalDirectorshipID,//localStorage.getItem('directorshipId'),
        DirectorID: directorID,
        OfficeName: this.directorshipForm.controls.OfficeName.value,
        OfficeType: this.directorshipForm.controls.OfficeType.value,
        CIN: this.directorshipForm.controls.CIN.value,
        AppointmentDate: this.setDate(this.directorshipForm.controls.AppointmentDate.value),
        Designation: this.directorshipForm.controls.Designation.value,
        CessationDate: this.setDate(this.directorshipForm.controls.CessationDate.value),
        //  IsSection8: this.directorshipForm.controls.IsSection8.value,
        PAN: this.directorshipForm.controls.PAN.value,
        ShareHolding: this.directorshipForm.controls.ShareHolding.value,
        DormantCompany: this.directorshipForm.controls.DormantCompany.value,
        OtherCompany: this.directorshipForm.controls.OtherCompany.value,
        OtherNatureOfIntrest: this.directorshipForm.controls.OtherNatureOfIntrest.value,
        CommitteeType: this.directorshipForm.controls.CommitteeType.value,
        OtherCommittee: this.directorshipForm.controls.OtherCommittee.value,
        IsActive: true,
        IsAuthorize: false,
        IsRectify: false,
        ModifiedBy: null,
        ModifiedDate: new Date()
      }
    }
    this.DirectorMasterService.addDirector(updateDirectorshipData)
      .subscribe(directorshipUpdate => {
        if (directorshipUpdate.status == 0) {
           
          $("#directorshipDialog").modal('toggle');
          this.alert.success("Directorship details updated successfully.");
          this.clearDirectorship();
          //localStorage.removeItem('directorshipId');
          if (localStorage.getItem('DirectorID') != undefined) {
            this.loadDirectorshipDetails(localStorage.getItem('DirectorID'));
          }
          else if (localStorage.getItem('updateDirectorId') != undefined) {
            this.loadDirectorshipDetails(localStorage.getItem('updateDirectorId'));
          }
        }
        else {
          $("#directorshipDialog").modal('toggle');
          this.alert.error(directorshipUpdate.message);
        }
      });
  }

  openOfficeHeldOrRelinquishedModal() {
     
    this.getNatureOfInterestInDisclosureOfIntrest();
    this.globalDirectorshipID = undefined;
    $('#myModalOfficeHeldOrRelinquishedLabel').html('<i class="fa fa-plus"></i>Add Offices held or relinquished :');
    $("#inputdirectorshipOfficeName").focus();
    $("#btnaddDirectorshipRow").html('<i class="fa fa-save"></i>Save');
    this.directorshipForm.controls.CommitteeType.setValue("null");
    this.directorshipForm.controls.Designation.setValue("");
    this.directorshipForm.controls['CessationDate'].disable();
  }


  fetchSubDirectorRow(i) {
    $('#myModalSecuritiesDetailsLabel').html("<i class='fa fa-pencil'></i>Edit Details of securities held in the Company, its Holding Company, Subsidiaries, Subsidiaries of the Company's Holding Company and Associate Companies:");
    $("#btnaddSubDirectorshipRow").html('<i class="fa fa-save"></i>Update Security Details');
    let dt;
    this.subDirectorForm.controls.CompanyName.setValue(this.subdirectorarray[i].CompanyName);
    //this.subDirectorForm.controls.NumberOfSecurities.setValue(this.subdirectorarray[i].NumberOfSecurities);
    this.subDirectorForm.controls.NumberOfSecurities.setValue(this.subdirectorarray[i].NumberOfSecurities);
    this.subDirectorForm.controls.SecurityDescription.setValue(this.subdirectorarray[i].SecurityDescription);
    this.subDirectorForm.controls.SecurityNominalValue.setValue(this.subdirectorarray[i].SecurityNominalValue);
    if (this.subdirectorarray[i].AcquisitionDate) {
      dt = new Date(this.setFormatDate(this.subdirectorarray[i].AcquisitionDate));
      this.AcquisitionDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.subDirectorForm.controls.AcquisitionPaidPrize.setValue(this.subdirectorarray[i].AcquisitionPaidPrize);
    this.subDirectorForm.controls.AcquisitionOtherPrize.setValue(this.subdirectorarray[i].AcquisitionOtherPrize);
    if (this.subdirectorarray[i].DisposalDate) {
      dt = new Date(this.setFormatDate(this.subdirectorarray[i].DisposalDate));
      this.DisposalDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.subDirectorForm.controls.NumberOfSharesDisposed.setValue(this.subdirectorarray[i].NumberOfSharesDisposed);
    this.subDirectorForm.controls.DisposalPrize.setValue(this.subdirectorarray[i].DisposalPrize);
    this.subDirectorForm.controls.DisposalReceivedPrize.setValue(this.subdirectorarray[i].DisposalReceivedPrize);
    this.subDirectorForm.controls.CumulativePrize.setValue(this.subdirectorarray[i].CumulativePrize);
    this.subDirectorForm.controls.AcquisitionSecuritiesMode.setValue(this.subdirectorarray[i].AcquisitionSecuritiesMode);
    if (this.subdirectorarray[i].HoldingMode != null) {
      this.subDirectorForm.controls.HoldingMode.setValue(this.subdirectorarray[i].HoldingMode);
    }
    else {
      this.subDirectorForm.controls.HoldingMode.setValue(null);
    }
    this.subDirectorForm.controls.PledgedSecurities.setValue(this.subdirectorarray[i].PledgedSecurities);
    this.subDirectorForm.controls.Shareholding.setValue(this.subdirectorarray[i].Shareholding);
    //localStorage.setItem('subdirectorId', this.subdirectorarray[i]._id);
    this.globalSubdirectorID = this.subdirectorarray[i]._id;
  }

  // localStorage.getItem('updateDirectorId') != undefined &&
  SubdirectorInsertUpdate() {
    if (this.globalSubdirectorID != undefined) {
      this.updateSubDirector();
    }
    else {
      this.addSubDirector();
    }
  }

  addSubDirector() {
    if (this.subDirectorForm.status == "VALID") {
       
      var directorID = "";
      if (localStorage.getItem('DirectorID') != undefined) {
        directorID = localStorage.getItem('DirectorID');
      }
      else if (localStorage.getItem('updateDirectorId') != undefined) {
        directorID = localStorage.getItem('updateDirectorId');
      }
      if (directorID == "") {
        $("#subdirectorDialog").modal('toggle');
        this.alert.error("Please first insert Personal Director details.");
        return false;
      }
      var subdirector = {
        "SubDirector": {
          DirectorID: directorID,
          CompanyName: this.subDirectorForm.controls.CompanyName.value,
          NumberOfSecurities: this.subDirectorForm.controls.NumberOfSecurities.value,
          //NumberOfSecurities:parseInt(this.subDirectorForm.controls.NumberOfSecurities.value.replace(new RegExp(this.escapeRegExp(','), 'g'), '')),
          SecurityDescription: this.subDirectorForm.controls.SecurityDescription.value,
          SecurityNominalValue: this.subDirectorForm.controls.SecurityNominalValue.value,
          AcquisitionDate: this.setDate(this.subDirectorForm.controls.AcquisitionDate.value),
          AcquisitionPaidPrize: this.subDirectorForm.controls.AcquisitionPaidPrize.value,
          AcquisitionOtherPrize: this.subDirectorForm.controls.AcquisitionOtherPrize.value,
          DisposalDate: this.setDate(this.subDirectorForm.controls.DisposalDate.value),
          NumberOfSharesDisposed: this.subDirectorForm.controls.NumberOfSharesDisposed.value,
          //NumberOfSharesDisposed:parseInt(this.subDirectorForm.controls.NumberOfSharesDisposed.value.replace(new RegExp(this.escapeRegExp(','), 'g'), '')),
          DisposalPrize: this.subDirectorForm.controls.DisposalPrize.value,
          DisposalReceivedPrize: this.subDirectorForm.controls.DisposalReceivedPrize.value,
          CumulativePrize: this.subDirectorForm.controls.CumulativePrize.value,
          //CumulativePrize:parseInt(this.subDirectorForm.controls.CumulativePrize.value.replace(new RegExp(this.escapeRegExp(','), 'g'), '')),
          AcquisitionSecuritiesMode: this.subDirectorForm.controls.AcquisitionSecuritiesMode.value,
          HoldingMode: this.subDirectorForm.controls.HoldingMode.value,
          PledgedSecurities: this.subDirectorForm.controls.PledgedSecurities.value,
          Shareholding: this.subDirectorForm.controls.Shareholding.value,
        }
      }
      this.DirectorMasterService.addDirector(subdirector)
        .subscribe(subdirector => {
          if (subdirector.status == 0) {
             
            $("#subdirectorDialog").modal('toggle');
            this.alert.success("Subdirector details saved successfully.");
            this.messagePopUpTimeoutToogle4();
            this.loadSubDirectorDetails(directorID);
            this.clearSubDirector();
          }
          else {
            $("#subdirectorDialog").modal('toggle');
            this.alert.error(subdirector.message);
          }
        });
    }
  }

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  updateSubDirector() {
     
    var directorId = "";
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var subDirectorData = {
      "SubDirector": {
        _id: this.globalSubdirectorID,
        DirectorID: directorId,
        CompanyName: this.subDirectorForm.controls.CompanyName.value,
        NumberOfSecurities: this.subDirectorForm.controls.NumberOfSecurities.value,
        //NumberOfSecurities:parseInt(this.subDirectorForm.controls.NumberOfSecurities.value.replace(new RegExp(this.escapeRegExp(','), 'g'), '')),
        SecurityDescription: this.subDirectorForm.controls.SecurityDescription.value,
        SecurityNominalValue: this.subDirectorForm.controls.SecurityNominalValue.value,
        AcquisitionDate: this.setDate(this.subDirectorForm.controls.AcquisitionDate.value),
        AcquisitionPaidPrize: this.subDirectorForm.controls.AcquisitionPaidPrize.value,
        AcquisitionOtherPrize: this.subDirectorForm.controls.AcquisitionOtherPrize.value,
        DisposalDate: this.setDate(this.subDirectorForm.controls.DisposalDate.value),
        NumberOfSharesDisposed: this.subDirectorForm.controls.NumberOfSharesDisposed.value,
        //NumberOfSharesDisposed:parseInt(this.subDirectorForm.controls.NumberOfSharesDisposed.value.replace(new RegExp(this.escapeRegExp(','), 'g'), '')),
        DisposalPrize: this.subDirectorForm.controls.DisposalPrize.value,
        DisposalReceivedPrize: this.subDirectorForm.controls.DisposalReceivedPrize.value,
        CumulativePrize: this.subDirectorForm.controls.CumulativePrize.value,
        //CumulativePrize:parseInt(this.subDirectorForm.controls.CumulativePrize.value.replace(new RegExp(this.escapeRegExp(','), 'g'), '')),
        AcquisitionSecuritiesMode: this.subDirectorForm.controls.AcquisitionSecuritiesMode.value,
        HoldingMode: this.subDirectorForm.controls.HoldingMode.value,
        PledgedSecurities: this.subDirectorForm.controls.PledgedSecurities.value,
        Shareholding: this.subDirectorForm.controls.Shareholding.value,
        IsActive: true,
        IsAuthorize: false,
        IsRectify: false,
        ModifiedBy: null,
        ModifiedDate: new Date()
      }
    }
    this.DirectorMasterService.addDirector(subDirectorData)
      .subscribe(subDirectorUpdate => {
        if (subDirectorUpdate.status == 0) {
           
          $("#subdirectorDialog").modal('toggle');
          this.alert.success("Security details updated successfully.");
          this.clearSubDirector();
          this.loadSubDirectorDetails(directorId);
          localStorage.removeItem('subdirectorId');
        }
        else {
          $("#subdirectorDialog").modal('toggle');
          this.alert.error(subDirectorUpdate.message);
        }
      });
  }

  openAddSubDirectorModal() {
    this.globalSubdirectorID = undefined;
    $('#myModalSecuritiesDetailsLabel').html("<i class='fa fa-plus'></i>Add Details of securities held in the Company, its Holding Company, Subsidiaries, Subsidiaries of the Company's Holding Company and Associate Companies:");
    $("#btnaddSubDirectorshipRow").html('<i class="fa fa-save"></i>Save Security Details');
    this.subDirectorForm.controls['DisposalDate'].disable();
  }

  clearSubDirector() {
    this.subDirectorForm.controls.CompanyName.setValue('');
    this.subDirectorForm.controls.NumberOfSecurities.setValue('');
    this.subDirectorForm.controls.SecurityDescription.setValue('');
    this.subDirectorForm.controls.SecurityNominalValue.setValue('');
    this.subDirectorForm.controls.AcquisitionPaidPrize.setValue('');
    this.subDirectorForm.controls.AcquisitionOtherPrize.setValue('');
    this.subDirectorForm.controls.NumberOfSharesDisposed.setValue('');
    this.subDirectorForm.controls.DisposalPrize.setValue('');
    this.subDirectorForm.controls.DisposalReceivedPrize.setValue('');
    this.subDirectorForm.controls.CumulativePrize.setValue('');
    this.subDirectorForm.controls.AcquisitionSecuritiesMode.setValue('');
    this.subDirectorForm.controls.PledgedSecurities.setValue('');
    this.subDirectorForm.controls.Shareholding.setValue('');
    this.subDirectorForm.controls.AcquisitionDate.setValue(null);
    this.subDirectorForm.controls.DisposalDate.setValue(null);
    this.subDirectorForm.controls.HoldingMode.setValue(null);
  }

  RemoveSubDirector() {
    //this.subdirectorarray.splice(index, 1);
     
    this.DirectorMasterService.removeSubDirector(this.deleteSubDirectorID)
      .subscribe((subDirectorRemove:any) => {
        if (subDirectorRemove.status == 0) {
           
          this.alert.success("Directorship details deleted successfully.");
          this.clearDirectorship();
          if (localStorage.getItem('DirectorID') != undefined) {
            this.loadSubDirectorDetails(localStorage.getItem('DirectorID'));
          }
          else if (localStorage.getItem('updateDirectorId') != undefined) {
            this.loadSubDirectorDetails(localStorage.getItem('updateDirectorId'));
          }
          $("#deletesubdirectorconfirmation").modal('toggle');
        }
        else {
          this.alert.error(subDirectorRemove.message);
        }
      });
  }
  get PermenantResidentialAddress(): any { return this.directorContactDetailsForm.get('PermenantResidentialAddress'); }
  get PresentResidentialAddress(): any { return this.directorContactDetailsForm.get('PresentResidentialAddress'); }
  get OfficeAddress(): any { return this.directorContactDetailsForm.get('OfficeAddress'); }


  // loadSubDirectorDetails(directorId) {
  //   this.DirectorMasterService.getDirectorDetails(directorId)
  //     .subscribe(director => {
  //       if (director.status == 0) {
  //         var table = $('#subDirectorTable').DataTable({ destroy: true });
  //         table.destroy();
  //         this.subdirectorarray = director.directorDetails[0].SubDirectorData;
  //         this.dtTriggerOfSubDirector.next();
  //       }
  //     });
  // }

  // loadRelativesDetails(directorId) {
  //   //  this.relativesArray = [];
  //   this.DirectorMasterService.getDirectorDetails(directorId)
  //     .subscribe(director => {
  //       if (director.status == 0) {
  //         var table = $('#relativeTable').DataTable({ destroy: true });
  //         table.destroy();
  //         this.relativesArray = director.directorDetails[0].RelativeData;
  //         this.dtTriggerOfRelative.next();
  //       }
  //     });
  // }
  KMPIsAvailable: boolean = true;
  availableKMPID: any = null;
  isKmp: boolean = false;

  loadDirectorDetails(directorId) {
    let dt;

    if (!this.environmentSettings.PSS) {
      this.directorMasterForm.controls['EmailID'].disable();
    }

    this.DirectorMasterService.getDirectorDetails(directorId)
      .subscribe((director:any) => {
        if (director.status == 0) {
          this.saveButtonhide = true;
          this.saveProfessionalButton = true;
          this.saveContactButton = true;

          this.directorMasterForm.controls.Din.setValue(director.directorMasterResult[0].Din);
          this.directorMasterForm.controls.FirstName.setValue(director.directorMasterResult[0].FirstName);
          this.directorMasterForm.controls.MiddleName.setValue(director.directorMasterResult[0].MiddleName);
          this.directorMasterForm.controls.LastName.setValue(director.directorMasterResult[0].LastName);

          $('#breadCrumbAddDirectorTitle, #pageTitle').html("Director Details (" + director.directorMasterResult[0].FirstName + " " + director.directorMasterResult[0].LastName + ")");

          this.directorMasterForm.controls.FatherFirstName.setValue(director.directorMasterResult[0].FatherFirstName);
          this.directorMasterForm.controls.FatherMiddleName.setValue(director.directorMasterResult[0].FatherMiddleName);
          this.directorMasterForm.controls.FatherLastName.setValue(director.directorMasterResult[0].FatherLastName);
          this.directorMasterForm.controls.MotherFirstName.setValue(director.directorMasterResult[0].MotherFirstName);
          this.directorMasterForm.controls.MotherMiddleName.setValue(director.directorMasterResult[0].MotherMiddleName);
          this.directorMasterForm.controls.MotherLastName.setValue(director.directorMasterResult[0].MotherLastName);
          this.directorMasterForm.controls.EmailID.setValue(director.directorMasterResult[0].EmailID);
          this.KMPIsAvailable = director.directorMasterResult[0].directorAsKMP.isAvailable;
          this.availableKMPID = director.directorMasterResult[0].directorAsKMP.kmpID;
          this.isKmp = false;
          if (director.directorMasterResult[0].DateOfBirth != null) {
            dt = new Date(this.setFormatDate(director.directorMasterResult[0].DateOfBirth));
            this.DateOfBirthModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
          }
          this.directorMasterForm.controls.BirthPlace.setValue(director.directorMasterResult[0].BirthPlace);
          this.directorMasterForm.controls.BirthPlace.setValue(director.directorMasterResult[0].BirthPlace);
          if (director.directorMasterResult[0].Gender == 'Male') {
            this.directorMasterForm.controls.Gender.setValue('Male');
          }
          else if (director.directorMasterResult[0].Gender == 'Female') {
            this.directorMasterForm.controls.Gender.setValue('Female');
          }
          else if (director.directorMasterResult[0].Gender == 'Transgender') {
            this.directorMasterForm.controls.Gender.setValue('Transgender');
          }

          if (director.directorMasterResult[0].Nationality != null) {
            this.directorMasterForm.controls.Nationality.setValue(director.directorMasterResult[0].Nationality);
          }
          else {
            this.directorMasterForm.controls.Nationality.setValue(null);
          }
          if (director.directorMasterResult[0].Resident) {
            this.directorMasterForm.controls.Resident.setValue('true');
          }
          else {
            this.directorMasterForm.controls.Resident.setValue('false');
          }
          this.directorMasterForm.controls.Occupation.setValue(director.directorMasterResult[0].Occupation);
          this.directorMasterForm.controls.EducationalQualification.setValue(director.directorMasterResult[0].EducationalQualification);
          this.directorMasterForm.controls.PAN.setValue(director.directorMasterResult[0].PAN);
          if (director.directorMasterResult[0].IsMarried) {
            this.directorMasterForm.controls.IsMarried.setValue('true');
            this.directorMasterForm.controls.SpouseFirstName.setValue(director.directorMasterResult[0].SpouseFirstName);
            this.directorMasterForm.controls.SpouseMiddleName.setValue(director.directorMasterResult[0].SpouseMiddleName);
            this.directorMasterForm.controls.SpouseLastName.setValue(director.directorMasterResult[0].SpouseLastName);
            this.showMarridYes = true;
          }
          else {
            this.directorMasterForm.controls.IsMarried.setValue('false');
            this.showMarridYes = false;
          }
          if (director.directorDetails[0].DirectorProfessional[0] != undefined) {
            this.designationArray = [];
            localStorage.setItem('professionalDetailId', director.directorDetails[0].DirectorProfessional[0]._id);
            $("#saveUpdateDirectorProfessionalDetails").html('<i class="fa fa-save"></i>Update');
            if (director.directorDetails[0].DirectorProfessional[0].IsExecutive) {
              this.directorProfessionalDetailsForm.controls.IsExecutive.setValue('true');
              this.designationArray = DataArray.executiveDesignationList;
              this.categoryArray = [];
              this.categoryArray = DataArray.executiveCategoryList;
            }
            else {
              this.directorProfessionalDetailsForm.controls.IsExecutive.setValue('false');
              // this.designationArray = DataArray.executiveDesignationList;
              this.designationArray = DataArray.nonExecutiveDesignationList;
              this.categoryArray = [];
              this.categoryArray = DataArray.categoryList;
            }
            if (director.directorDetails[0].DirectorProfessional[0].IsRetiringDirector) {
              this.directorProfessionalDetailsForm.controls.IsRetiringDirector.setValue('true');
            }
            else {
              this.directorProfessionalDetailsForm.controls.IsRetiringDirector.setValue('false');
            }
            if (director.directorDetails[0].DirectorProfessional[0].Designation != "") {
              this.directorProfessionalDetailsForm.controls.Designation.setValue(director.directorDetails[0].DirectorProfessional[0].Designation);
            }
            else {
              this.directorProfessionalDetailsForm.controls.Designation.setValue(null);
            }
            if (director.directorDetails[0].DirectorProfessional[0].Category != "") {
              this.directorProfessionalDetailsForm.controls.Category.setValue(director.directorDetails[0].DirectorProfessional[0].Category);
            }
            else {
              this.directorProfessionalDetailsForm.controls.Category.setValue(null);
            }
            if (director.directorDetails[0].DirectorProfessional[0].BoardResolutionDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].BoardResolutionDate));
              this.BoardResolutionDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }

            if (director.directorDetails[0].DirectorProfessional[0].AppointmentDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].AppointmentDate));
              this.AppointmentDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].AppointmentDIR12FillingDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].AppointmentDIR12FillingDate));
              this.AppointmentDIR12FillingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].ReAppointmentDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].ReAppointmentDate));
              this.ReAppointmentDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].PreAppointmentDates != null && director.directorDetails[0].DirectorProfessional[0].PreAppointmentDates != '') {

              try {
                this.preAppointmentDateschange(JSON.parse(director.directorDetails[0].DirectorProfessional[0].PreAppointmentDates));
              } catch (exception) {
                this.preAppointmentDateschange([]);
              }
            } else {
              this.preAppointmentDateschange([]);
            }
            if (director.directorDetails[0].DirectorProfessional[0].CessationDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].CessationDate));
              this.CessationDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].ResignationDIR11filingDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].ResignationDIR11filingDate));
              this.ResignationDIR11filingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].CessationType != "") {
              this.directorProfessionalDetailsForm.controls.CessationType.setValue(director.directorDetails[0].DirectorProfessional[0].CessationType);
            }
            else {
              this.directorProfessionalDetailsForm.controls.CessationType.setValue(null);
            }
            if (director.directorDetails[0].DirectorProfessional[0].CessationType == "Any other") {
              this.ShowOtherCessationType = true;
              this.directorProfessionalDetailsForm.controls.OtherCessationType.setValue(director.directorDetails[0].DirectorProfessional[0].OtherCessationType);
            }
            else {
              this.ShowOtherCessationType = false;
              this.directorProfessionalDetailsForm.controls.OtherCessationType.setValue(null);
            }
            this.directorProfessionalDetailsForm.controls.CessationReason.setValue(director.directorDetails[0].DirectorProfessional[0].CessationReason);
            if (director.directorDetails[0].DirectorProfessional[0].AppointmentCompletionDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].AppointmentCompletionDate));
              this.AppointmentCompletionDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].DisqualificationDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].DisqualificationDate));
              this.DisqualificationDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            this.directorProfessionalDetailsForm.controls.DisqualificationDetails.setValue(director.directorDetails[0].DirectorProfessional[0].DisqualificationDetails);
            if (director.directorDetails[0].DirectorProfessional[0].RemovalDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].RemovalDate));
              this.RemovalDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].NoticeReceivedDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].NoticeReceivedDate));
              this.NoticeReceivedDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].RemovalDIR12FilingDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].RemovalDIR12FilingDate));
              this.RemovalDIR12FilingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].ResignationEffectiveDate != null) {
              dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorProfessional[0].ResignationEffectiveDate));
              this.ResignationEffectiveDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            }
            if (director.directorDetails[0].DirectorProfessional[0].IsChairman == 'true' || director.directorDetails[0].DirectorProfessional[0].IsChairman == true) {
              console.log("if");
              this.directorProfessionalDetailsForm.controls.IsChairman.setValue('true');
            }
            else {
              console.log("else");
              this.directorProfessionalDetailsForm.controls.IsChairman.setValue('false');

            }

            this.set10FieldsValues(director.directorDetails[0]);






          }
          else {
            localStorage.removeItem('professionalDetailId');
            $("#saveUpdateDirectorProfessionalDetails").html('<i class="fa fa-save"></i>Save');
          }


          if (director.directorDetails[0].DirectorContact[0] != undefined) {
            localStorage.setItem('contactDetailId', director.directorDetails[0].DirectorContact[0]._id);
            $("#saveUpdateDirectorContactDetails").html('<i class="fa fa-save"></i>Update');
            this.OfficeAddress.controls.Line1.setValue(director.directorDetails[0].DirectorContact[0].OfficeAddress.Line1);
            this.OfficeAddress.controls.Line2.setValue(director.directorDetails[0].DirectorContact[0].OfficeAddress.Line2);
            if (director.directorDetails[0].DirectorContact[0].OfficeAddress.Country != "") {
              this.OfficeAddress.controls.Country.setValue(director.directorDetails[0].DirectorContact[0].OfficeAddress.Country);
            }
            else {
              this.OfficeAddress.controls.Country.setValue(null);
            }
            if (director.directorDetails[0].DirectorContact[0].OfficeAddress.State != "") {
              this.OfficeAddress.controls.State.setValue(director.directorDetails[0].DirectorContact[0].OfficeAddress.State);
            }
            else {
              this.OfficeAddress.controls.State.setValue(null);
            }
            this.OfficeAddress.controls.City.setValue(director.directorDetails[0].DirectorContact[0].OfficeAddress.City);
            this.OfficeAddress.controls.PinCode.setValue(director.directorDetails[0].DirectorContact[0].OfficeAddress.PinCode);
            this.PermenantResidentialAddress.controls.Line1.setValue(director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Line1);
            this.PermenantResidentialAddress.controls.Line2.setValue(director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Line2);
            if (director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Country != "") {
              this.PermenantResidentialAddress.controls.Country.setValue(director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Country);
            }
            else {
              this.PermenantResidentialAddress.controls.Country.setValue(null);
            }
            if (director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.State != "") {
              this.PermenantResidentialAddress.controls.State.setValue(director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.State);
            }
            else {
              this.PermenantResidentialAddress.controls.State.setValue(null);
            }
            this.PermenantResidentialAddress.controls.City.setValue(director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.City);
            this.PermenantResidentialAddress.controls.PinCode.setValue(director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.PinCode);

            this.PresentResidentialAddress.controls.Line1.setValue(director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Line1);
            this.PresentResidentialAddress.controls.Line2.setValue(director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Line2);
            if (director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Country != "") {
              this.PresentResidentialAddress.controls.Country.setValue(director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Country);
            }
            else {
              this.PresentResidentialAddress.controls.Country.setValue(null);
            }
            if (director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.State != "") {
              this.PresentResidentialAddress.controls.State.setValue(director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.State);
            }
            else {
              this.PresentResidentialAddress.controls.State.setValue(null);
            }
            this.PresentResidentialAddress.controls.City.setValue(director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.City);
            this.PresentResidentialAddress.controls.PinCode.setValue(director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.PinCode);


            if (director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.PinCode == director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.PinCode
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Line1 == director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Line1
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Line2 == director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Line2
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.State == director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.State
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Country == director.directorDetails[0].DirectorContact[0].PermenantResidentialAddress.Country
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.PinCode != ""
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Line1 != ""
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Line2 != ""
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.State != ""
              && director.directorDetails[0].DirectorContact[0].PresentResidentialAddress.Country != "") {
              console.log('Setting True', true);
              this.directorContactDetailsForm.controls.isAddressSame.setValue(true);
              this.directorContactDetailsForm.controls.isAddressSame.setValue("true");
            } else {
              this.directorContactDetailsForm.controls.isAddressSame.setValue(false);
              this.directorContactDetailsForm.controls.isAddressSame.setValue("false");
            }

            this.directorContactDetailsForm.controls.OfficeTelephoneNumber.setValue(director.directorDetails[0].DirectorContact[0].OfficeTelephoneNumber);
            this.directorContactDetailsForm.controls.ResidentTelephoneNumber.setValue(director.directorDetails[0].DirectorContact[0].ResidentTelephoneNumber);
            this.directorContactDetailsForm.controls.Fax.setValue(director.directorDetails[0].DirectorContact[0].Fax);
            this.directorContactDetailsForm.controls.MobileNumber.setValue(director.directorDetails[0].DirectorContact[0].MobileNumber);
            this.directorContactDetailsForm.controls.AadhaarNumber.setValue(director.directorDetails[0].DirectorContact[0].AadhaarNumber);
            this.directorContactDetailsForm.controls.IdentityNumber.setValue(director.directorDetails[0].DirectorContact[0].IdentityNumber);
            this.directorContactDetailsForm.controls.PassportNumber.setValue(director.directorDetails[0].DirectorContact[0].PassportNumber);
            this.directorContactDetailsForm.controls.DrivingLicenseNumber.setValue(director.directorDetails[0].DirectorContact[0].DrivingLicenseNumber);
            // this.directorContactDetailsForm.controls.FunctionalAreas.setValue(director.directorDetails[0].DirectorContact[0].FunctionalAreas);
            // if (director.directorDetails[0].DirectorContact[0].DesignationDIR12FillingDate != null) {
            //   dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorContact[0].DesignationDIR12FillingDate));
            //   this.DesignationDIR12FillingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            // }
            // if (director.directorDetails[0].DirectorContact[0].PromoterGroupDirector) {
            //   this.directorContactDetailsForm.controls.PromoterGroupDirector.setValue('true');
            // }
            // else {
            //   this.directorContactDetailsForm.controls.PromoterGroupDirector.setValue('false');
            // }
            // if (director.directorDetails[0].DirectorContact[0].IsSittingFeesEligible) {
            //   console.log('-----IsSittingFeesEligible----', director.directorDetails[0].DirectorContact[0].IsSittingFeesEligible);
            //   this.directorContactDetailsForm.controls.IsSittingFeesEligible.setValue('true');
            // }
            // else {
            //   this.directorContactDetailsForm.controls.IsSittingFeesEligible.setValue('false');
            // }
            // this.directorContactDetailsForm.controls.AllMeetingSittingFees.setValue(director.directorDetails[0].DirectorContact[0].AllMeetingSittingFees);
            // this.directorContactDetailsForm.controls.MeetingAttendedNumber.setValue(director.directorDetails[0].DirectorContact[0].MeetingAttendedNumber);
            // this.directorContactDetailsForm.controls.Commission.setValue(director.directorDetails[0].DirectorContact[0].Commission);
            // this.directorContactDetailsForm.controls.Remuneration.setValue(director.directorDetails[0].DirectorContact[0].Remuneration);
            // if (director.directorDetails[0].DirectorContact[0].DSCSigningDate != null) {
            //   dt = new Date(this.setFormatDate(director.directorDetails[0].DirectorContact[0].DSCSigningDate));
            //   this.DSCSigningDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
            // }
            // this.directorContactDetailsForm.controls.DisqualifiedDirector.setValue(director.directorDetails[0].DirectorContact[0].DisqualifiedDirector);
          }
          else {
            localStorage.removeItem('contactDetailId');
            $("#saveUpdateDirectorContactDetails").html('<i class="fa fa-save"></i>Save');
          }
          if (director.directorDetails[0].DirectorshipData != undefined) {
            // var table = $('#directorshipTable').DataTable({ destroy: true });
            // table.destroy();
            //this.directorshipArray = [];
            //this.allDirectorshipArray = director.directorDetails[0].DirectorshipData;
            //this.directorshipArray = director.directorDetails[0].DirectorshipData;
            // this.allDirectorshipArray.forEach(element => {
            //   if (moment().diff(moment(element.AppointmentDate), "days") >= 0 && (moment().diff(moment(element.CessationDate), "days") <= 0 || element.CessationDate == null)) {
            //     this.directorshipArray.push(element);
            //   }
            // });
            const self = this;
            this.getDirectorship(function (response) {
              self.directorshipArray = response.directorshipData;
              self.dtTriggerOfDirectorship.next();
            });
            // this.dtTriggerOfDirectorship.next();
          }
          if (director.directorDetails[0].SubDirectorData != undefined) {
            // var table = $('#subDirectorTable').DataTable({ destroy: true });
            // table.destroy();
            // this.subdirectorarray = director.directorDetails[0].SubDirectorData;
            // this.dtTriggerOfSubDirector.next();
            const self = this;
            this.getSubdirector(function (response) {
              self.subdirectorarray = response.subDirectorData;
              self.dtTriggerOfSubDirector.next();
            });
          }
          if (director.directorDetails[0].RelativeData != undefined) {
            this.relativesArray = []
            var table = $('#relativeTable').DataTable({ destroy: true });
            table.destroy();
            this.relativesArray = director.directorDetails[0].RelativeData;
            // this.dtTriggerOfRelative.next();
            const self = this;
            this.getRelatives(function (response) {
              self.relativesArray = response.directorshipData;
              self.dtTriggerOfRelative.next();
            });
          }
          this.error = { isError: false, errorMessage: '' }
        }
      });
  }
  addRelatives() {
    if (this.relativesForm.status == "VALID") {
       
      var newdirectorID = "";
      if (localStorage.getItem('DirectorID') != undefined) {
        newdirectorID = localStorage.getItem('DirectorID');
      }
      else if (localStorage.getItem('updateDirectorId') != undefined) {
        newdirectorID = localStorage.getItem('updateDirectorId');
      }
      if (newdirectorID == "") {
        $("#relativeDialog").modal('toggle');
        this.alert.error("Please first insert Personal Director details.");
        return false;
      }
      var relativeData = {
        "addRelative":
        {
          CompanyID: null,
          DirectorID: newdirectorID,
          RelativeName: this.relativesForm.controls.RelativeName.value.trim(),
          Relationship: this.relativesForm.controls.Relationship.value,
          RelativePAN: this.relativesForm.controls.RelativePAN.value.toUpperCase(),
          FirmName: this.relativesForm.controls.FirmName.value.trim(),
          CompanyPAN: this.relativesForm.controls.CompanyPAN.value.trim(),
          FirmType: this.relativesForm.controls.FirmType.value,
          NatureOfIntrest: this.relativesForm.controls.NatureOfIntrest.value,
          IntrestDate: this.setDate(this.relativesForm.controls.IntrestDate.value),
          IntrestChange: this.relativesForm.controls.IntrestChange.value,
          IntrestChangeDate: this.setDate(this.relativesForm.controls.IntrestChangeDate.value),
          Shareholding: this.relativesForm.controls.Shareholding.value,
          OtherCompanyForRelative: this.relativesForm.controls.OtherCompanyForRelative.value,
          OtherNatureOfIntrestForRelative: this.relativesForm.controls.OtherNatureOfIntrestForRelative.value,
          CIN: this.relativesForm.controls.CIN.value,
          DormantCompany: this.relativesForm.controls.DormantCompany.value,
          CommitteeType: this.relativesForm.controls.CommitteeType.value,
          OtherCommittee: this.relativesForm.controls.OtherCommittee.value,
          Status: true
        }
      }
      this.DirectorMasterService.addRelatives(relativeData)
        .subscribe((relatives:any) => {
          if (relatives.status == 0) {
             
            $("#relativeDialog").modal('toggle');
            this.alert.success("Relatives' details saved successfully.");
            this.loadRelativesDetails(newdirectorID);
            this.clearRelatives();
          }
          else {
            $("#relativeDialog").modal('toggle');
            this.alert.error(relatives.message);
            this.clearRelatives();
          }
        });
    }
  }

  addAndUpdateRelative() {
     

    if (this.globalRelativeID != undefined) {
      this.updateRelatives();
    }
    else {
      this.addRelatives();
    }
  }

  getAddedRelatives(directorPAN) {
    if (directorPAN == "" || directorPAN == undefined) {
      return false;
    }
    this.relativesArray = [];
    this.DirectorMasterService.getRelativesDetails(directorPAN)
      .subscribe((relativeDirectorList:any) => {
         
        if (relativeDirectorList.status == 0) {
          this.relativesArray = relativeDirectorList.relatives;
          this.dtTriggerOfRelative.next();
        }
        else {
          this.alert.error(relativeDirectorList.message);
        }
      });
  }

  openAddRelativeModal() {
    this.getNatureOfInterestInDisclosureOfIntrest();
    this.globalRelativeID = undefined;
    $('#myModalRelativeDetailsLabel').html("<i class='fa fa-plus'></i>Add Relatives' Details");
    $("#btnaddandUpdateRelativesRow").html('<i class="fa fa-save"></i>Save');
    this.relativesForm.controls['IntrestChangeDate'].disable();
  }

  fetchRelatives(i) {
    $('#myModalRelativeDetailsLabel').html("<i class='fa fa-pencil'></i>Edit Relatives' Details");
    $("#btnaddandUpdateRelativesRow").html('<i class="fa fa-save"></i>Update');
    let dt;
    // localStorage.setItem('updateRelativeId', this.relativesArray[i]._id);
    this.globalRelativeID = this.relativesArray[i]._id;
    this.relativesForm.controls.RelativeName.setValue(this.relativesArray[i].RelativeName);
    this.relativesForm.controls.Relationship.setValue(this.relativesArray[i].Relationship);
    this.relativesForm.controls.RelativePAN.setValue(this.relativesArray[i].RelativePAN);
    this.relativesForm.controls.FirmName.setValue(this.relativesArray[i].FirmName);
    this.relativesForm.controls.CompanyPAN.setValue(this.relativesArray[i].CompanyPAN);
    this.relativesForm.controls.FirmType.setValue(this.relativesArray[i].FirmType);
    this.relativesForm.controls.NatureOfIntrest.setValue(this.relativesArray[i].NatureOfIntrest);
    if (this.relativesArray[i].IntrestDate != null) {
      dt = new Date(this.setFormatDate(this.relativesArray[i].IntrestDate));
      this.IntrestDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.relativesForm.controls.IntrestChange.setValue(this.relativesArray[i].IntrestChange);
    if (this.relativesArray[i].IntrestChangeDate != null) {
      dt = new Date(this.setFormatDate(this.relativesArray[i].IntrestChangeDate));
      this.IntrestChangeDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    if (this.relativesArray[i].NatureOfIntrest == "Member") {
      this.showShareholdingInRelative = true;
      this.relativesForm.controls.Shareholding.setValue(this.relativesArray[i].Shareholding);
    }
    else {
      this.showShareholdingInRelative = false;
      this.relativesForm.controls.Shareholding.setValue(null);
    }
    if (this.relativesArray[i].NatureOfIntrest == "Others") {
      this.showOtherNatureForRelative = true;
      this.relativesForm.controls.OtherNatureOfIntrestForRelative.setValue(this.relativesArray[i].OtherNatureOfIntrestForRelative);
    }
    else {
      this.showOtherNatureForRelative = false;
      this.relativesForm.controls.OtherNatureOfIntrestForRelative.setValue(null);
    }
    if (this.relativesArray[i].FirmType == "Others") {
      this.showOtherCompanyForRelative = true;
      this.relativesForm.controls.OtherCompanyForRelative.setValue(this.relativesArray[i].OtherCompanyForRelative);
    }
    else {
      this.showOtherCompanyForRelative = false;
      this.relativesForm.controls.OtherCompanyForRelative.setValue(null);
    }

    if (this.relativesArray[i].FirmType != null) {
      var event = {
        target: {
          value: this.relativesArray[i].FirmType
        }
      };
      this.setNatureOfIntrest(event);
    }

    console.log('this.relativesArray[i].DormantCompany', this.relativesArray[i])
    if (this.relativesArray[i].FirmType == "Private Limited Company" || this.relativesArray[i].FirmType == "OPC" || this.relativesArray[i].FirmType == "Public Unlisted Company") {
      this.showDormantStateRelative = true;
      this.relativesForm.controls.DormantCompany.setValue('true');
    }
    else {
      this.showDormantStateRelative = false;
      this.relativesForm.controls.DormantCompany.setValue('false');
    }


    if (this.relativesArray[i].FirmType == "Private Debt Listed Company" || this.relativesArray[i].FirmType == "Private Limited Company" || this.relativesArray[i].FirmType == "Public Listed Company"
      || this.relativesArray[i].FirmType == "Public Unlisted Company" || this.relativesArray[i].FirmType == "Section 8 Company" || this.relativesArray[i].FirmType == "OPC"
      || this.relativesArray[i].FirmType == "Foreign Company") {
      this.showCINRelative = true;
      this.relativesForm.controls.CIN.setValue(this.relativesArray[i].CIN);
    }
    else {
      this.showCINRelative = false;
      this.relativesForm.controls.CIN.setValue(null);
    }



    this.saveRelativeButton = true;
    this.updateRelativeButton = false;
    if (this.relativesArray[i].NatureOfIntrest == "Committee Member" || this.relativesArray[i].NatureOfIntrest == "Committee Chairman") {
      this.showRelativeCommitee = true;
      this.showRelativeOtherCommitee = false;
      this.relativesForm.controls.CommitteeType.setValue(this.relativesArray[i].CommitteeType);
      if (this.relativesArray[i].CommitteeType == "Others") {
        this.showRelativeOtherCommitee = true;
        this.relativesForm.controls.OtherCommittee.setValue(this.relativesArray[i].OtherCommittee);
      }
      else {
        this.showRelativeOtherCommitee = false;
      }
    }
    else {
      this.showCommitee = false;
      this.relativesForm.controls.CommitteeType.setValue(null);
    }


  }


  updateRelatives() {
    // var relativeId = "";
    var memberShareholding = "";
    // if (localStorage.getItem('updateRelativeId') != undefined) {
    //   relativeId = localStorage.getItem('updateRelativeId');
    // }
    var directorID = "";
    if (localStorage.getItem('DirectorID') != undefined) {
      directorID = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorID = localStorage.getItem('updateDirectorId');
    }
    if (this.relativesForm.controls.NatureOfIntrest.value == "Member") {
      memberShareholding = this.relativesForm.controls.Shareholding.value;
    }
    else {
      memberShareholding = null;
    }
    var relativeData = {
      "updateRelative":
      {
        _id: this.globalRelativeID,
        DirectorID: directorID,
        CompanyID: null,
        RelativeName: this.relativesForm.controls.RelativeName.value.trim(),
        Relationship: this.relativesForm.controls.Relationship.value,
        RelativePAN: this.relativesForm.controls.RelativePAN.value.toUpperCase(),
        FirmName: this.relativesForm.controls.FirmName.value.trim(),
        CompanyPAN: this.relativesForm.controls.CompanyPAN.value.trim(),
        FirmType: this.relativesForm.controls.FirmType.value,
        NatureOfIntrest: this.relativesForm.controls.NatureOfIntrest.value,
        IntrestDate: this.setDate(this.relativesForm.controls.IntrestDate.value),
        IntrestChange: this.relativesForm.controls.IntrestChange.value,
        IntrestChangeDate: this.setDate(this.relativesForm.controls.IntrestChangeDate.value),
        Shareholding: memberShareholding,
        OtherCompanyForRelative: this.relativesForm.controls.OtherCompanyForRelative.value,
        OtherNatureOfIntrestForRelative: this.relativesForm.controls.OtherNatureOfIntrestForRelative.value,
        CIN: this.relativesForm.controls.CIN.value,
        DormantCompany: this.relativesForm.controls.DormantCompany.value,
        CommitteeType: this.relativesForm.controls.CommitteeType.value,
        OtherCommittee: this.relativesForm.controls.OtherCommittee.value,
        Status: true
      }
    }
    this.DirectorMasterService.updateRelativeDetails(relativeData)
      .subscribe((relativeUpdate:any) => {
        if (relativeUpdate.status == 0) {
           
          $("#relativeDialog").modal('toggle');
          this.alert.success("Relatives' details updated successfully.");
          this.loadRelativesDetails(directorID);
          this.clearRelatives();
          this.updateRelativeButton = true;
          this.saveRelativeButton = false;
          //localStorage.removeItem('updateRelativeId');
        }
        else {
          $("#relativeDialog").modal('toggle');
          this.alert.error(relativeUpdate.message);
          this.clearRelatives();
        }
      });
  }

  clearRelatives() {
     
    this.relativesForm.controls.RelativeName.setValue('');
    this.relativesForm.controls.Relationship.setValue('');
    this.relativesForm.controls.RelativePAN.setValue('');
    this.relativesForm.controls.FirmName.setValue('');
    this.relativesForm.controls.CompanyPAN.setValue('');
    this.relativesForm.controls.FirmType.setValue(null);
    this.relativesForm.controls.NatureOfIntrest.setValue(null);
    this.relativesForm.controls.IntrestDate.setValue(null);
    this.relativesForm.controls.IntrestChange.setValue('');
    this.relativesForm.controls.IntrestChangeDate.setValue(null);
    this.relativesForm.controls.Shareholding.setValue('');
    this.showRelativeCommitee = false;
    this.showRelativeOtherCommitee = false;
    this.showOtherNatureForRelative = false;
    this.showOtherCompanyForRelative = false;
    this.showShareholdingInRelative = false;
  }

  removeRelatives() {
    //this.subdirectorarray.splice(index, 1);
     
    this.DirectorMasterService.removeRelative(this.deleteRelativeID)
      .subscribe((relativesRemove:any) => {
        if (relativesRemove.status == 0) {
           
          if (localStorage.getItem('DirectorID') != undefined) {
            this.loadRelativesDetails(localStorage.getItem('DirectorID'));
          }
          else if (localStorage.getItem('updateDirectorId') != undefined) {
            this.loadRelativesDetails(localStorage.getItem('updateDirectorId'));
          }
          $("#deleterelativeconfirmation").modal('toggle');
          this.alert.success("Relative details deleted successfully.");
        }
        else {
          $("#deleterelativeconfirmation").modal('toggle');
          this.alert.error(relativesRemove.message);
        }
      });
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  messagePopUpTimeoutToogle1() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp1').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp1').modal('toggle');
      }
    }, 3000);
  }

  messagePopUpTimeoutToogle2() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp2').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp2').modal('toggle');
      }
    }, 3000);
  }

  messagePopUpTimeoutToogle3() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp3').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp3').modal('toggle');
      }
    }, 3000);
  }

  messagePopUpTimeoutToogle4() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp4').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp4').modal('toggle');
      }
    }, 3000);
  }

  messagePopUpTimeoutToogle5() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp5').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp5').modal('toggle');
      }
    }, 3000);
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyNumberWithoutDecimal(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyAlphabtes(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(keyCode >= 65 && keyCode <= 120) && (keyCode != 32 && keyCode != 0 && keyCode != 9)) {
      ev.preventDefault();
    }
  }

  onlyPrize(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9) || (keyCode == 190)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  DinNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 8 digits
      if ((ev.target.value + ev.key).length > 8) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  aadharNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 12 digits
      if ((ev.target.value + ev.key).length > 12) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }

  presentaddressIssame() {
    this.PresentResidentialAddress.controls.Line1.setValue(this.PermenantResidentialAddress.controls.Line1.value);
    this.PresentResidentialAddress.controls.Line2.setValue(this.PermenantResidentialAddress.controls.Line2.value);
    this.PresentResidentialAddress.controls.City.setValue(this.PermenantResidentialAddress.controls.City.value);
    this.PresentResidentialAddress.controls.PinCode.setValue(this.PermenantResidentialAddress.controls.PinCode.value);
    this.PresentResidentialAddress.controls.Country.setValue(this.PermenantResidentialAddress.controls.Country.value);
    this.PresentResidentialAddress.controls.State.setValue(this.PermenantResidentialAddress.controls.State.value);
  }


  permenantaddressIsnotsame() {
    this.PresentResidentialAddress.controls.Line1.setValue('');
    this.PresentResidentialAddress.controls.Line2.setValue('');
    this.PresentResidentialAddress.controls.Country.setValue(null);
    this.PresentResidentialAddress.controls.State.setValue(null);
    this.PresentResidentialAddress.controls.City.setValue('');
    this.PresentResidentialAddress.controls.PinCode.setValue('');
  }

  clearAll() {
    this.clearDirector();
    this.clearProfessionalDetails();
    this.clearContactDetails();
    this.clearDirectorship();
    this.clearSubDirector();
    this.clearRelatives();
  }

  clearDirectorConfirmation() {
    $('#personalConfirmation').modal('toggle');
  }

  clearDirectorProfessionalConfirmation() {
    $('#professionalConfirmation').modal('toggle');
  }

  clearContactConfirmation() {
    $("#contactConfirmation").modal('toggle');
  }

  removeDirectorshipConfirmation(directorshipID) {
    this.deleteDirectorshipID = directorshipID;
    $("#deletedirectorshipconfirmation").modal('toggle');
  }

  removeSubdirectorConfirmation(subDirectorID) {
    this.deleteSubDirectorID = subDirectorID;
    $("#deletesubdirectorconfirmation").modal('toggle');
  }

  removeRelativeConfirmation(relativeID) {
    this.deleteRelativeID = relativeID;
    $("#deleterelativeconfirmation").modal('toggle');
  }

  setdormantCompany(ev) {
    var typeOfCompany = ev.target.value;
    if (typeOfCompany == "Private Limited Company" || typeOfCompany == "OPC" || typeOfCompany == "Public Unlisted Company") {
      this.showDormantState = true;
      this.directorshipForm.controls.DormantCompany.setValue('false');
    }
    else {
      this.showDormantState = false;
      this.directorshipForm.controls.DormantCompany.setValue('false');
    }
  }

  setdormantCompanyRelative(ev) {
    var typeOfCompany = ev.target.value;
    if (typeOfCompany == "Private Limited Company" || typeOfCompany == "OPC" || typeOfCompany == "Public Unlisted Company") {
      this.showDormantStateRelative = true;
      this.relativesForm.controls.DormantCompany.setValue('false');
    }
    else {
      this.showDormantStateRelative = false;
      this.relativesForm.controls.DormantCompany.setValue('false');
    }
  }

  setNatureOfIntrest(ev) {
     
    var typeOfCompany = ev.target.value;
    if (typeOfCompany == "null") {
      this.getNatureOfInterestInDisclosureOfIntrest();
    }
    this.bodycorporateArray.forEach(element => {
      if (element.BodyCorporate == typeOfCompany) {
        this.natureOfIntrestArray = this.commonFunction.sortByKey(element.NatureOfIntrest, 'Nature');
      }
    });

    this.directorshipForm.controls.Designation.setValue("");
    this.showOtherNatureOfIntrest = false;
    this.showCommitee = false;
    this.showShareHolding = false;
    this.showOtherCommitee = false;
    this.showRelativeCommitee = false;
    this.showRelativeOtherCommitee = false;
  }

  setCIN(ev) {
    var getTypeOfCompanyForCIN = ev.target.value;
    if (getTypeOfCompanyForCIN == "Private Debt Listed Company" || getTypeOfCompanyForCIN == "Private Limited Company" || getTypeOfCompanyForCIN == "Public Listed Company"
      || getTypeOfCompanyForCIN == "Public Unlisted Company" || getTypeOfCompanyForCIN == "Section 8 Company" || getTypeOfCompanyForCIN == "OPC"
      || getTypeOfCompanyForCIN == "Foreign Company") {
      this.showCIN = true;
      this.directorshipForm.controls.CIN.setValue(null);
    }
    else {
      this.showCIN = false;
      this.directorshipForm.controls.CIN.setValue(null);
    }
  }
  setCINRelative(ev) {
    var getTypeOfCompanyForCIN = ev.target.value;
    if (getTypeOfCompanyForCIN == "Private Debt Listed Company" || getTypeOfCompanyForCIN == "Private Limited Company" || getTypeOfCompanyForCIN == "Public Listed Company"
      || getTypeOfCompanyForCIN == "Public Unlisted Company" || getTypeOfCompanyForCIN == "Section 8 Company" || getTypeOfCompanyForCIN == "OPC"
      || getTypeOfCompanyForCIN == "Foreign Company") {
      this.showCINRelative = true;
      this.relativesForm.controls.CIN.setValue(null);
    }
    else {
      this.showCINRelative = false;
      this.relativesForm.controls.CIN.setValue(null);
    }

  }

  setOtherCompany(ev) {
    var otherCompany = ev.target.value;
    if (otherCompany == "Others") {
      this.showOtherCompany = true;
      this.directorshipForm.controls.OtherCompany.setValue(null);
    }
    else {
      this.directorshipForm.controls.OtherCompany.setValue(null);
      this.showOtherCompany = false;
    }
  }

  setOtherNatureOfIntrest(ev) {
    var otherNatureOfIntrest = ev.target.value;
    if (otherNatureOfIntrest == "Others") {
      this.showOtherNatureOfIntrest = true;
      this.directorshipForm.controls.OtherNatureOfIntrest.setValue(null);
    }
    else {
      this.directorshipForm.controls.OtherNatureOfIntrest.setValue(null);
      this.showOtherNatureOfIntrest = false;
    }
  }

  setShareHolding(ev) {
    var natureOfIntrestValue = ev.target.value;
    if (natureOfIntrestValue == "Member") {
      this.showShareHolding = true;
    }
    else {
      this.showShareHolding = false;
    }
  }

  setCommittee(ev) {
    var natureOfIntrestIsCommittee = ev.target.value;
    if (natureOfIntrestIsCommittee == "Committee Chairman" || natureOfIntrestIsCommittee == "Committee Member") {
      this.showCommitee = true;
      this.directorshipForm.controls.CommitteeType.setValue(null);
      this.showOtherCommitee = false;
      this.directorshipForm.controls.OtherCommittee.setValue(null);
    }
    else {
      this.showCommitee = false;
      this.showOtherCommitee = false;
      this.directorshipForm.controls.OtherCommittee.setValue(null);
    }
  }



  showRelativeCommitee: any;
  showRelativeOtherCommitee: any;
  setCommitteeForRelative(ev) {
    var natureOfIntrestIsCommittee = ev.target.value;
    if (natureOfIntrestIsCommittee == "Committee Chairman" || natureOfIntrestIsCommittee == "Committee Member") {
      this.showRelativeCommitee = true;
      this.relativesForm.controls.CommitteeType.setValue(null);
      this.showRelativeOtherCommitee = false;
      this.relativesForm.controls.OtherCommittee.setValue(null);
    }
    else {
      this.showRelativeCommitee = false;
      this.showRelativeOtherCommitee = false;
      this.relativesForm.controls.CommitteeType.setValue(null);
      this.relativesForm.controls.OtherCommittee.setValue(null);
    }
  }

  setRelativeOtherCommittee(ev) {
    var otherRelativeCommitee = ev.target.value;
    if (otherRelativeCommitee == "Others") {
      this.relativesForm.controls.OtherCommittee.setValue(null);
      this.showRelativeOtherCommitee = true;
    }
    else {
      this.relativesForm.controls.OtherCommittee.setValue(null);
      this.showRelativeOtherCommitee = false;
    }
  }

  setOtherCommittee(ev) {
    var otherCommitee = ev.target.value;
    if (otherCommitee == "Others") {
      this.directorshipForm.controls.OtherCommittee.setValue(null);
      this.showOtherCommitee = true;
    }
    else {
      this.showOtherCommitee = false;
    }
  }

  cumulativeCalculationOnNumberOfShareDisposed() {
     

    if (this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel) > this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel)) {
      this.IsNumberOfSharesLarge = true;
      this.cumulativeBalanceModel = null;
      return false;
    }
    else if (this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) >= this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel)) {
      this.IsNumberOfSharesLarge = false;
      this.cumulativeBalanceModel = this.commonFunction.formatToCommaSeperatedNumber(this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) - this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel));
      this.IsNumberOfSecurityLess = false;
      return true;
    }
    else if (this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) >= 0 && this.NumberOfSharesDisposedModel == "") {
      this.cumulativeBalanceModel = this.NumberOfSecuritiesModel;
    }
    else if (this.NumberOfSharesDisposedModel == "") {
      this.cumulativeBalanceModel = null;
      this.IsNumberOfSecurityLess = false;
    }
  }

  cumulativeCalculationOnNumberOfSecurities() {
     
    if (this.NumberOfSharesDisposedModel != "") {
      if (this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) < this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel)) {
        this.IsNumberOfSecurityLess = true;
        this.cumulativeBalanceModel = null;
      }
      else if (this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel) <= this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel)) {
        this.cumulativeBalanceModel = this.commonFunction.formatToCommaSeperatedNumber(this.convertCommaSeparatedToNumber(this.NumberOfSecuritiesModel) - this.convertCommaSeparatedToNumber(this.NumberOfSharesDisposedModel));
        this.IsNumberOfSecurityLess = false;
        this.IsNumberOfSharesLarge = false;
      }
    }
    else {
      this.cumulativeBalanceModel = this.NumberOfSecuritiesModel;
    }
  }

  getMultiplePreappointmentDate() {

    let flag = true;

    for (var i = 0; i < this.preAppointmentsDateArray.length; i++) {
      if (this.preAppointmentsDateArray[i] == "") {
      }
      if (this.preAppointmentsDateArray[i] === (this.setPreappointmentDate(this.PreAppointmentDateModel))) {
        flag = false;
      }
    }

    if (flag) {
      if (this.PreAppointmentDateModel != null) {
        this.preAppointmentsDateArray.push((this.setPreappointmentDate(this.PreAppointmentDateModel)));
        $(".select2").val(this.preAppointmentsDateArray);
      }
    }

  }



  showShareholdingForRelative(ev) {
    if (ev.target.value == "Member") {
      this.showShareholdingInRelative = true;
    }
    else {
      this.showShareholdingInRelative = false;
    }
  }

  setOtherCompanyInRelative(ev) {
    var otherCompanyInRelative = ev.target.value;
    if (otherCompanyInRelative == "Others") {
      this.showOtherCompanyForRelative = true;
      this.relativesForm.controls.OtherCompanyForRelative.setValue(null);
    }
    else {
      this.relativesForm.controls.OtherCompanyForRelative.setValue(null);
      this.showOtherCompanyForRelative = false;
    }
  }

  otherNatureOfIntrestInRelative(ev) {
    var NatureOfIntrestInRelative = ev.target.value;
    if (NatureOfIntrestInRelative == "Others") {
      this.showOtherNatureForRelative = true;
      this.relativesForm.controls.OtherNatureOfIntrestForRelative.setValue(null);
    }
    else {
      this.relativesForm.controls.OtherNatureOfIntrestForRelative.setValue(null);
      this.showOtherNatureForRelative = false;
    }
  }

  OtherCessationType(ev) {
    var OtherCessationType = ev.target.value;
    if (OtherCessationType == "Any other") {
      this.ShowOtherCessationType = true;
      this.directorProfessionalDetailsForm.controls.OtherCessationType.setValue(null);
    }
    else {
      this.ShowOtherCessationType = false;
      this.directorProfessionalDetailsForm.controls.OtherCessationType.setValue(null);
    }
  }


  tabDisclosureOfInterestOnClickEvent() {
    // setTimeout(() => {
    //   $("#directorshipTable").DataTable().columns.adjust().draw();
    // });
    // this.dtTriggerOfDirectorship.next();

    var filterDate = JSON.parse(localStorage.getItem('inputdatadirectors'));
    console.log(filterDate)

    if (filterDate != null) {
      if (filterDate.ToDate != null) {
        let dt = new Date(this.commonFunction.setFormatDate(filterDate.ToDate))
        this.ToDateModelInDirectorship = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      }

      if (filterDate.FromDate != null) {
        let dt = new Date(this.commonFunction.setFormatDate(filterDate.FromDate))
        this.FromDateModelInDirectorship = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      }
    }

    this.getDirectorshipByParam();
  }

  tabSecurityHeldOnClickEvent() {

    // setTimeout(() => {
    //   $("#subDirectorTable").DataTable().columns.adjust().draw();
    // });        
    // setTimeout(() => {
    //   $("#subDirectorTable").DataTable().columns.adjust().draw();
    // });
    // this.dtTriggerOfSubDirector.next();
    var filterDate = JSON.parse(localStorage.getItem('inputdatadirectors'));
    if (filterDate != null) {
      if (filterDate.ToDate != null) {
        let dt = new Date(this.commonFunction.setFormatDate(filterDate.ToDate))
        this.ToDateModelInSubDirector = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      }

      if (filterDate.FromDate != null) {
        let dt = new Date(this.commonFunction.setFormatDate(filterDate.FromDate))
        this.FromDateModelInSubDirector = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }
      }
    }

    this.getSubDirectorByParam();
  }

  tabRelativeDetailsOnClickEvent() {

    // setTimeout(() => {
    //   $("#relativeTable").DataTable().columns.adjust().draw();
    // });
    // this.dtTriggerOfRelative.next();
    this.getRelativesByParam();
  }

  adjustDataTableColumns(tableId) {

    $("#directorshipTable").DataTable().columns.adjust().draw();
    $("#subDirectorTable").DataTable().columns.adjust().draw();
    $("#relativeTable").DataTable().columns.adjust().draw();
  }

  destroyDataTable(tableId) {

    this.dtElements.forEach((dtElement: DataTableDirective, index: number) => {
      if (tableId == "directorshipTable" && index == 0) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      } else if (tableId == "subDirectorTable" && index == 1) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      } else if (tableId == "relativeTable" && index == 2) {
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      }
    });

  }

  clearDirectorship() {
    this.directorshipForm.controls.OfficeName.setValue('');
    this.directorshipForm.controls.CIN.setValue('');
    this.directorshipForm.controls.ShareHolding.setValue('');
    this.directorshipForm.controls.AppointmentDate.setValue(null);
    this.directorshipForm.controls.CessationDate.setValue(null);
    this.directorshipForm.controls.PAN.setValue('');
    this.directorshipForm.controls.OfficeType.setValue(null);
    this.directorshipForm.controls.Designation.setValue('');
    this.directorshipForm.reset();
    this.showCIN = false;
    this.showDormantState = false;
    this.showOtherCompany = false;
    this.showOtherNatureOfIntrest = false;
    this.showCommitee = false;
    this.showOtherCommitee = false;
  }


  countryList: any[];
  getAllNations() {
    this.DirectorMasterService.getNations()
      .subscribe((relativeUpdate:any) => {
        console.log(relativeUpdate);
        this.countryList = this.commonFunction.sortByKey(relativeUpdate.countryList, 'Country');
      });
  }

  setCessationAndReappointmentDate(ev) {
    this.checkAppointmentDateDirector();
    if (ev == null) {
      this.directorProfessionalDetailsForm.controls['CessationDate'].disable();
      this.directorProfessionalDetailsForm.controls['ReAppointmentDate'].disable();
      this.directorProfessionalDetailsForm.controls['AppointmentDIR12FillingDate'].disable();
      this.directorProfessionalDetailsForm.controls['RemovalDate'].disable();
      return;
    }
    var appointmentDate = new Date(this.setDate(ev));
    var setFutureDateByAppointmentDate = new Date(moment(appointmentDate));
    this.FutureCessationDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.FutureReappointmentDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.FutureDIR12FillingDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.FutureRemovalDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.FutureDSCSigningDate = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.directorProfessionalDetailsForm.controls['CessationDate'].enable();
    this.directorProfessionalDetailsForm.controls['ReAppointmentDate'].enable();
    this.directorProfessionalDetailsForm.controls['AppointmentDIR12FillingDate'].enable();
    this.directorProfessionalDetailsForm.controls['RemovalDate'].enable();
    if (this.CessationDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.AppointmentDateModel).diff(moment(this.CessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInProfessional = true;
      }
      else {
        this.IsCessationDatePriorInProfessional = false;
      }
    }
    if (this.ReAppointmentDateModel != null) {
      var diffReAppointmentDateAppointmentDate = (moment(this.AppointmentDateModel).diff(moment(this.ReAppointmentDateModel), "days"));
      if (diffReAppointmentDateAppointmentDate > 0) {
        this.IsReappointmentDatePriorInProfessional = true;
      }
      else {
        this.IsReappointmentDatePriorInProfessional = false;
      }
    }
    if (this.AppointmentDIR12FillingDateModel != null) {
      var diffDIR12FillingDateAppointmentDate = (moment(this.AppointmentDateModel).diff(moment(this.AppointmentDIR12FillingDateModel), "days"));
      if (diffDIR12FillingDateAppointmentDate > 0) {
        this.IsDIR12FillingDatePriorInProfessional = true;
      }
      else {
        this.IsDIR12FillingDatePriorInProfessional = false;
      }
    }
    if (this.RemovalDateModel != null) {
      var diffAppointmentDateRemovalDate = (moment(this.AppointmentDateModel).diff(moment(this.RemovalDateModel), "days"));
      if (diffAppointmentDateRemovalDate > 0) {
        this.IsRemovalDatePriorInProfessional = true;
      }
      else {
        this.IsRemovalDatePriorInProfessional = false;
      }
    }
  }

  setCessationDateAsRemoval(ev) {
     
    if (ev != null) {
      var removalDate = new Date(this.setDate(ev));
      this.CessationDateModel = { month: removalDate.getMonth() + 1, day: removalDate.getDate(), year: removalDate.getFullYear() };
    }
  }

  onlyTwoDecimal(ev) {
    $('.dacimalFix').on('input', function () {
      this.value = this.value.replace(/(\.[\d]{2})./g, '$1'); // not more than 2 digits after decimal
    });
  }

  convertCommaSeparatedToNumber(number) {

    let convertNumber = number.toString().replace(/\,/g, '');
    if (convertNumber != '') {
      let convertedNumber = parseFloat(convertNumber);
      return convertedNumber;
    }
  }

  getCompanyTypeInDisclosureOfIntrest() {
     
    this.DirectorMasterService.getCompanyType()
      .subscribe((companyType:any) => {
      console.log(companyType)

        if (companyType.status == 0) {
          this.bodycorporateArray = companyType.companyTypeList;
        }
        else {
          this.alert.error(companyType.message);
        }
      });
  }

  getNatureOfInterestInDisclosureOfIntrest() {
    //  
    this.DirectorMasterService.getNatureOfInterest()
      .subscribe((natureOfInterest:any) => {
      console.log(natureOfInterest)

        if (natureOfInterest.status == 0) {

          this.natureOfIntrestArray = natureOfInterest.natureOfInterestList;

        }
        else {
          this.alert.error(natureOfInterest.message);
        }
      });
  }

  setCessationDateInDirectorship(ev) {
    var appointmentDate = new Date(this.setDate(ev));
    var setFutureDateByAppointmentDate = new Date(moment(appointmentDate));
    this.FutureCessationDateInDirectorship = { year: setFutureDateByAppointmentDate.getFullYear(), month: setFutureDateByAppointmentDate.getMonth() + 1, day: setFutureDateByAppointmentDate.getDate() };
    this.directorshipForm.controls['CessationDate'].enable();
    if (this.dirCessationDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.dirAppointmentDateModel).diff(moment(this.dirCessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInDirectorship = true;
      }
      else {
        this.IsCessationDatePriorInDirectorship = false;
      }
    }
  }

  setDisposalDateInSubdirector(ev) {
    var acquisitionDate = new Date(this.setDate(ev));
    var setFutureDateByAcquisitionDate = new Date(moment(acquisitionDate));
    this.FutureDisposalDateInSubdirector = { year: setFutureDateByAcquisitionDate.getFullYear(), month: setFutureDateByAcquisitionDate.getMonth() + 1, day: setFutureDateByAcquisitionDate.getDate() };
    this.subDirectorForm.controls['DisposalDate'].enable();
    if (this.DisposalDateModel != null) {
      var diffAcquisitionDateAndDisposal = (moment(this.AcquisitionDateModel).diff(moment(this.DisposalDateModel), "days"));
      if (diffAcquisitionDateAndDisposal > 0) {
        this.IsDisposalDatePriorInSubdirector = true;
      }
      else {
        this.IsDisposalDatePriorInSubdirector = false;
      }
    }
  }

  setIntrestChangeDateInRelative(ev) {
     
    if (ev == null) {
      this.IntrestChangeDateModel = null;
      this.relativesForm.controls['IntrestChangeDate'].disable();
      this.IsInterestChangeDatePriorInRelative = false;
      return false;
    }
    var intrestDate = new Date(this.setDate(ev));
    var setFutureDateByIntrestDate = new Date(moment(intrestDate));
    this.FutureIntrestChangeDate = { year: setFutureDateByIntrestDate.getFullYear(), month: setFutureDateByIntrestDate.getMonth() + 1, day: setFutureDateByIntrestDate.getDate() };
    this.relativesForm.controls['IntrestChangeDate'].enable();
    if (this.IntrestChangeDateModel != null) {
      var diffIntrestDateAndIntrestChangeDate = (moment(this.IntrestDateModel).diff(moment(this.IntrestChangeDateModel), "days"));
      if (diffIntrestDateAndIntrestChangeDate > 0) {
        this.IsInterestChangeDatePriorInRelative = true;
      }
      else {
        this.IsInterestChangeDatePriorInRelative = false;
      }
    }
  }

  CessationDateIsPriorToAppointmentDate() {
    if (this.dirAppointmentDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.dirAppointmentDateModel).diff(moment(this.dirCessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInDirectorship = true;
      }
      else {
        this.IsCessationDatePriorInDirectorship = false;
      }
    }
  }

  DisposalDateIsPriorToAcquisitionDate() {
    if (this.AcquisitionDateModel != null) {
      var diffAcquisitionDateDisposalDate = (moment(this.AcquisitionDateModel).diff(moment(this.DisposalDateModel), "days"));
      if (diffAcquisitionDateDisposalDate > 0) {
        this.IsDisposalDatePriorInSubdirector = true;
      }
      else {
        this.IsDisposalDatePriorInSubdirector = false;
      }
    }
  }

  InterestChangeDateIsPriorToInterestDate() {
    if (this.IntrestChangeDateModel != null) {
      var diffInterestDateIntrestChangeDate = (moment(this.IntrestDateModel).diff(moment(this.IntrestChangeDateModel), "days"));
      if (diffInterestDateIntrestChangeDate > 0) {
        this.IsInterestChangeDatePriorInRelative = true;
      }
      else {
        this.IsInterestChangeDatePriorInRelative = false;
      }
    }
  }

  CessationDateIsPriorToAppointmentDateInProfessional() {
    if (this.AppointmentDateModel != null) {
      var diffAppointmentDateCessationDate = (moment(this.AppointmentDateModel).diff(moment(this.CessationDateModel), "days"));
      if (diffAppointmentDateCessationDate > 0) {
        this.IsCessationDatePriorInProfessional = true;
      }
      else {
        this.IsCessationDatePriorInProfessional = false;
      }
      if (this.RemovalDateModel != null) {
        this.RemovalDateModel = this.CessationDateModel;
      }
      else {
        this.RemovalDateModel = null;
      }
    }
  }

  ReappointmentDateIsPriorToAppointmentDateInProfessional() {
    if (this.AppointmentDateModel != null) {
      var diffAppointmentDateReappointmentDate = (moment(this.AppointmentDateModel).diff(moment(this.ReAppointmentDateModel), "days"));
      if (diffAppointmentDateReappointmentDate > 0) {
        this.IsReappointmentDatePriorInProfessional = true;
      }
      else {
        this.IsReappointmentDatePriorInProfessional = false;
      }
    }
  }

  ReappointmentDateIsLaterToCessationDate() {
    if (this.CessationDateModel != null && this.ReAppointmentDateModel != null) {
      var diffCesationDateReappointmentDate = (moment(this.ReAppointmentDateModel).diff(moment(this.CessationDateModel), "days"));
      if (diffCesationDateReappointmentDate > 0) {
        this.IsReappointmentDateLaterInProfessional = true;
      }
      else {
        this.IsReappointmentDateLaterInProfessional = false;
      }
    }

  }

  DIR12FillingDateIsPriorToAppointmentDateInProfessional() {
    if (this.AppointmentDateModel != null) {
      var diffAppointmentDateDIR12FillingDate = (moment(this.AppointmentDateModel).diff(moment(this.AppointmentDIR12FillingDateModel), "days"));
      if (diffAppointmentDateDIR12FillingDate > 0) {
        this.IsDIR12FillingDatePriorInProfessional = true;
      }
      else {
        this.IsDIR12FillingDatePriorInProfessional = false;
      }
    }
  }

  // filter directorship by date

  adjustdirectorshipTable() {
    // var directorshipData = this.directorshipArray;
    // this.directorshipArray = [];
    // $("#directorshipTable").DataTable().destroy();
    // this.directorshipArray = directorshipData;
    // setTimeout(() => {
    //   $("#directorshipTable").DataTable().columns.adjust().draw();
    // }, 200);
    // this.dtTriggerOfDirectorship.next();
  }

  getDirectorshipByParam() {
    console.log("hit 1");
    this.response = true;
    var directorId = "";
    // this.directorshipArray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInDirectorship != null && this.ToDateModelInDirectorship == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInDirectorship).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInDirectorship == null && this.ToDateModelInDirectorship != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInDirectorship).toString();
    }
    if (this.FromDateModelInDirectorship != null && this.ToDateModelInDirectorship != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInDirectorship).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInDirectorship).toString();
    }
    if (this.FromDateModelInDirectorship == null && this.ToDateModelInDirectorship == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    // var table = $('#directorshipTable').DataTable({ destroy: true });
    // table.destroy();

    this.DirectorMasterService.getDirectorshipByDate(filterDate)
      .subscribe(directorshipData => {
        if (directorshipData.status == 0) {
          this.directorshipArray = [];
          $("#directorshipTable").DataTable().destroy();
          this.directorshipArray = directorshipData.directorshipData;
          this.response = false;
          this.dtTriggerOfDirectorship.next();
        }
        else {
          this.response = false;
          this.alert.error(directorshipData.message);
        }
      });
    //this.dtTriggerOfDirectorship.next();
    // this.adjustdirectorshipTable();
  }

  getDirectorshipByNullParam() {
    this.response = true;
    var directorId = "";
    this.futureFromDateInDisclosure = null;
    this.futureToDateInDisclosure = null;
    this.FromDateModelInDirectorship = null;
    this.ToDateModelInDirectorship = null;
    // this.directorshipArray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }

    // var table = $('#directorshipTable').DataTable({ destroy: true });
    // table.destroy();

    this.DirectorMasterService.getDirectorshipByDate(filterDate)
      .subscribe(directorshipData => {
        if (directorshipData.status == 0) {
          this.directorshipArray = [];
          $("#directorshipTable").DataTable().destroy();
          this.directorshipArray = directorshipData.directorshipData;
          this.response = false;

          this.dtTriggerOfDirectorship.next();
        }
        else {
          this.response = false;
          this.alert.error(directorshipData.message);
        }
      });
    // 
    // this.adjustdirectorshipTable();
  }

  getDirectorship(callback) {
    var directorId = "";
    this.FromDateModelInDirectorship = null;
    this.ToDateModelInDirectorship = null;
    this.directorshipArray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }

    var table = $('#directorshipTable').DataTable({ destroy: true });
    table.destroy();
    this.DirectorMasterService.getDirectorship(filterDate)
      .then(response => {
        if (response) {
          callback(response);
        }
      });
    this.dtTriggerOfDirectorship.next();
  }

  loadDirectorshipDetails(directorId) {
    //  
    // this.DirectorMasterService.getDirectorDetails(directorId)
    //   .subscribe(director => {
    //     if (director.status == 0) {
    //       this.directorshipArray = null;
    //       var table = $('#directorshipTable').DataTable({ destroy: true });
    //       table.destroy();
    //       this.directorshipArray = director.directorDetails[0].DirectorshipData;
    //       // this.directorshipArray = this.allDirectorshipArray;
    //       this.dtTriggerOfDirectorship.next();
    //     }
    //   });    
    this.FromDateModelInDirectorship = null;
    this.ToDateModelInDirectorship = null;
    this.directorshipArray = [];
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }
    const self = this;
    // var table = $('#directorshipTable').DataTable({ destroy: true });
    // table.destroy();
    this.directorshipArray = [];
    $("#directorshipTable").DataTable().destroy();
    this.DirectorMasterService.getDirectorship(filterDate)
      .then(response => {
        if (response) {
          self.directorshipArray = response.directorshipData;
          this.dtTriggerOfDirectorship.next();
        }
      });
    //
    // this.adjustdirectorshipTable();
  }

  //End of directorship

  // filter subdirecror by date

  adjustsubdirectorTable() {
    var subdirectorData = this.subdirectorarray;
    this.subdirectorarray = [];
    $("#subDirectorTable").DataTable().destroy();
    this.subdirectorarray = subdirectorData;
    setTimeout(() => {
      $("#subDirectorTable").DataTable().columns.adjust().draw();
    }, 200);
    this.dtTriggerOfSubDirector.next();
  }

  getSubdirector(callback) {
    var directorId = "";
    this.FromDateModelInSubDirector = null;
    this.ToDateModelInSubDirector = null;
    this.subdirectorarray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }
    this.subdirectorarray = [];
    $("#subDirectorTable").DataTable().destroy();
    // var table = $('#subDirectorTable').DataTable({ destroy: true });
    // table.destroy();
    this.subdirectorarray = [];
    $("#subDirectorTable").DataTable().destroy();
    this.DirectorMasterService.getSubDirector(filterDate)
      .then(response => {
        if (response) {
          callback(response);
        }
      });
    //this.dtTriggerOfSubDirector.next();
    // this.adjustsubdirectorTable();
  }

  loadSubDirectorDetails(directorId) {
    this.FromDateModelInSubDirector = null;
    this.ToDateModelInSubDirector = null;
    this.subdirectorarray = [];
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }
    const self = this;
    // var table = $('#subDirectorTable').DataTable({ destroy: true });
    // table.destroy();
    this.subdirectorarray = [];
    $("#subDirectorTable").DataTable().destroy();
    this.DirectorMasterService.getSubDirector(filterDate)
      .then(response => {
        if (response) {
          self.subdirectorarray = response.subDirectorData;
          this.dtTriggerOfSubDirector.next();
        }
      });
    // this.dtTriggerOfSubDirector.next();
    // this.adjustsubdirectorTable();
  }

  getSubDirectorByParam() {
    console.log("hit");
    this.response = true;
     
    var directorId = "";
    // this.subdirectorarray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInSubDirector != null && this.ToDateModelInSubDirector == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInSubDirector).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInSubDirector == null && this.ToDateModelInSubDirector != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInSubDirector).toString();
    }
    if (this.FromDateModelInSubDirector != null && this.ToDateModelInSubDirector != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInSubDirector).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInSubDirector).toString();
    }
    if (this.FromDateModelInSubDirector == null && this.ToDateModelInSubDirector == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    // var table = $('#subDirectorTable').DataTable({ destroy: true });
    // table.destroy();

    this.DirectorMasterService.getSubdirectorByDate(filterDate)
      .subscribe(subDirectorDetails => {
        if (subDirectorDetails.status == 0) {
          this.subdirectorarray = [];
          $("#subDirectorTable").DataTable().destroy();
          this.subdirectorarray = subDirectorDetails.subDirectorData;
          this.response = false;
          this.dtTriggerOfSubDirector.next();
        }
        else {
          this.response = false;
          this.alert.error(subDirectorDetails.message);
        }
      });
    // this.dtTriggerOfSubDirector.next();
    // this.adjustsubdirectorTable();
  }

  getSubDirectorByNullParam() {
    var directorId = "";
    this.FromDateModelInSubDirector = null;
    this.ToDateModelInSubDirector = null;
    this.futureFromDateInDetailsOfSecurity = null;
    this.futureToDateInDetailsOfSecurity = null;
    // this.subdirectorarray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }

    // var table = $('#subDirectorTable').DataTable({ destroy: true });
    // table.destroy();

    this.DirectorMasterService.getSubdirectorByDate(filterDate)
      .subscribe(subDirectorDetails => {
        if (subDirectorDetails.status == 0) {
          this.response = false;
          this.subdirectorarray = [];
          $("#subDirectorTable").DataTable().destroy();
          this.subdirectorarray = subDirectorDetails.subDirectorData;
          this.dtTriggerOfSubDirector.next();
        }
        else {
          this.alert.error(subDirectorDetails.message);
        }
      });
    // this.dtTriggerOfSubDirector.next();
    // this.adjustsubdirectorTable();
  }

  //End of Subdirector

  //filter relative by date

  adjustrelativeTable() {
    // var relativeData = this.relativesArray;
    // this.relativesArray = [];
    // $("#relativeTable").DataTable().destroy();
    // this.relativesArray = relativeData;

    // setTimeout(() => {
    //   $("#relativeTable").DataTable().columns.adjust().draw();
    // }, 200);
    // this.dtTriggerOfRelative.next();
  }


  getRelativesByParam() {
     
    this.response = true;
    var directorId = "";
    this.relativesArray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: "",
      ToDate: "",
    }
    if (this.FromDateModelInRelative != null && this.ToDateModelInRelative == null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInRelative).toString();
      filterDate.ToDate = null;
    }
    if (this.FromDateModelInRelative == null && this.ToDateModelInRelative != null) {
      filterDate.FromDate = null;
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInRelative).toString();
    }
    if (this.FromDateModelInRelative != null && this.ToDateModelInRelative != null) {
      filterDate.FromDate = this.commonFunction.setDate(this.FromDateModelInRelative).toString();
      filterDate.ToDate = this.commonFunction.setDate(this.ToDateModelInRelative).toString();
    }
    if (this.FromDateModelInRelative == null && this.ToDateModelInRelative == null) {
      filterDate.FromDate = null;
      filterDate.ToDate = null;
    }
    // var table = $('#relativeTable').DataTable({ destroy: true });
    // table.destroy();
    this.relativesArray = [];
    $("#relativeTable").DataTable().destroy();
    this.DirectorMasterService.getRelativesByDate(filterDate)
      .subscribe(relativeDetails => {
        if (relativeDetails.status == 0) {
          this.relativesArray = relativeDetails.relativeData;
          this.response = false;
          this.dtTriggerOfRelative.next();
        }
        else {
          this.alert.error(relativeDetails.message);
        }
      });
    //this.dtTriggerOfRelative.next();
    //this.adjustrelativeTable();
  }

  getRelativesByNullParam() {
    this.response = true;
    var directorId = "";
    this.FromDateModelInRelative = null;
    this.ToDateModelInRelative = null;
    this.futureFromDateInRelative = null;
    this.futureToDateInRelative = null;
    this.relativesArray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }
    this.relativesArray = [];
    $("#relativeTable").DataTable().destroy();
    // var table = $('#relativeTable').DataTable({ destroy: true });
    // table.destroy();
    this.DirectorMasterService.getRelativesByDate(filterDate)
      .subscribe(relativeDetails => {
        if (relativeDetails.status == 0) {
          this.relativesArray = relativeDetails.relativeData;
          this.response = false;
          this.dtTriggerOfRelative.next();
        }
        else {
          this.alert.error(relativeDetails.message);
        }
      });
    //this.dtTriggerOfRelative.next();
    // this.adjustrelativeTable();
  }

  getRelatives(callback) {
    var directorId = "";
    this.FromDateModelInRelative = null;
    this.ToDateModelInRelative = null;
    this.relativesArray = [];
    if (localStorage.getItem('DirectorID') != undefined) {
      directorId = localStorage.getItem('DirectorID');
    }
    else if (localStorage.getItem('updateDirectorId') != undefined) {
      directorId = localStorage.getItem('updateDirectorId');
    }
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }
    this.relativesArray = [];
    $("#relativeTable").DataTable().destroy();
    // var table = $('#relativeTable').DataTable({ destroy: true });
    // table.destroy();
    this.DirectorMasterService.getRelative(filterDate)
      .then(response => {
        if (response) {
          callback(response);
        }
      });
    //this.dtTriggerOfSubDirector.next();
    // this.adjustrelativeTable();
  }

  loadRelativesDetails(directorId) {
    this.FromDateModelInRelative = null;
    this.ToDateModelInRelative = null;
    this.relativesArray = [];
    var filterDate = {
      DirectorID: directorId,
      FromDate: null,
      ToDate: null,
    }
    const self = this;
    // var table = $('#relativeTable').DataTable({ destroy: true });
    // table.destroy();
    this.relativesArray = [];
    $("#relativeTable").DataTable().destroy();
    this.DirectorMasterService.getRelative(filterDate)
      .then(response => {
        if (response) {
          self.relativesArray = response.relativeData;
          this.dtTriggerOfRelative.next();
        }
      });
    //this.dtTriggerOfRelative.next();
    // this.adjustrelativeTable();
  }

  //End of relative

  setDesignationByExecutive() {
    this.directorProfessionalDetailsForm.controls.Designation.setValue('');
    this.designationArray = DataArray.executiveDesignationList;
    this.categoryArray = [];
    this.categoryArray = DataArray.executiveCategoryList;
    this.directorProfessionalDetailsForm.controls.Category.setValue('');
  }

  setDesignationByNonExecutive() {
    this.directorProfessionalDetailsForm.controls.Designation.setValue('');
    this.designationArray = DataArray.nonExecutiveDesignationList;
    this.categoryArray = [];
    this.categoryArray = DataArray.categoryList;
    this.directorProfessionalDetailsForm.controls.Category.setValue('');
  }

  aboveEighteenYear() {
     
    if (this.DateOfBirthModel != null) {
      const date = moment({
        year: +this.DateOfBirthModel.year, month: (+this.DateOfBirthModel.month) - 1, day:
          +this.DateOfBirthModel.day
      }).startOf('day');
      const now = moment().startOf('day');
      if ((now.diff(date, 'years') >= 18) == true) {
        this.IsDateOfBirthValid = true;
      }
      else {
        this.IsDateOfBirthValid = false;
      }
    }
  }

  setTodateInDisclosure(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDateInDisclosure = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdateInDisclosure(ev) {
    if (ev != null) {
      var toDate = new Date(this.commonFunction.setDate(ev));
      var setFromDateByToDate = new Date(moment(toDate));
      this.futureFromDateInDisclosure = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
    }
  }

  setTodateInDetailsOfSecurity(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDateInDetailsOfSecurity = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdateInDetailsOfSecurity(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDateInDetailsOfSecurity = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }

  setTodateInRelative(ev) {
    var fromDate = new Date(this.commonFunction.setDate(ev));
    var setToDateByFromDate = new Date(moment(fromDate));
    this.futureToDateInRelative = { year: setToDateByFromDate.getFullYear(), month: setToDateByFromDate.getMonth() + 1, day: setToDateByFromDate.getDate() };
  }

  setFromdateInRelative(ev) {
    var toDate = new Date(this.commonFunction.setDate(ev));
    var setFromDateByToDate = new Date(moment(toDate));
    this.futureFromDateInRelative = { year: setFromDateByToDate.getFullYear(), month: setFromDateByToDate.getMonth() + 1, day: setFromDateByToDate.getDate() };
  }


  set10FieldsValues(data) {
    var FunctionalAreas = ''
    var DesignationDIR12FillingDate = null
    var PromoterGroupDirector = "false"
    var IsSittingFeesEligible = "false"
    var AllMeetingSittingFees = ""
    var MeetingAttendedNumber = ""
    var Commission = ""
    var Remuneration = ""
    var DSCSigningDate = null;
    var DisqualifiedDirector = ""
    var dt;

    console.log(data.DirectorProfessional);
    console.log(data.DirectorContact);
    // 1>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].FunctionalAreas === undefined) {
      if (data.DirectorContact[0].FunctionalAreas === undefined) {
        FunctionalAreas = ""
      }
      else {
        FunctionalAreas = data.DirectorContact[0].FunctionalAreas;
      }
    }
    else {
      FunctionalAreas = data.DirectorProfessional[0].FunctionalAreas;
    }

    // 2>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].DesignationDIR12FillingDate === undefined) {
      if (data.DirectorContact[0].DesignationDIR12FillingDate === undefined) {
        DesignationDIR12FillingDate = null
      }
      else {
        DesignationDIR12FillingDate = data.DirectorContact[0].DesignationDIR12FillingDate;
      }
    }
    else {
      DesignationDIR12FillingDate = data.DirectorProfessional[0].DesignationDIR12FillingDate;
    }

    // 3>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].PromoterGroupDirector === undefined) {
      if (data.DirectorContact[0].PromoterGroupDirector === undefined) {
        PromoterGroupDirector = "false"
      }
      else {
        PromoterGroupDirector = data.DirectorContact[0].PromoterGroupDirector;
      }
    }
    else {
      PromoterGroupDirector = data.DirectorProfessional[0].PromoterGroupDirector;
    }

    // 4>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].IsSittingFeesEligible === undefined) {
      if (data.DirectorContact[0].IsSittingFeesEligible === undefined) {
        IsSittingFeesEligible = "false"
      }
      else {
        IsSittingFeesEligible = data.DirectorContact[0].IsSittingFeesEligible;
      }
    }
    else {
      IsSittingFeesEligible = data.DirectorProfessional[0].IsSittingFeesEligible;
    }

    // 5>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].AllMeetingSittingFees === undefined) {
      if (data.DirectorContact[0].AllMeetingSittingFees === undefined) {
        AllMeetingSittingFees = ""
      }
      else {
        AllMeetingSittingFees = data.DirectorContact[0].AllMeetingSittingFees;
      }
    }
    else {
      AllMeetingSittingFees = data.DirectorProfessional[0].AllMeetingSittingFees;
    }

    // 6>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].MeetingAttendedNumber === undefined) {
      if (data.DirectorContact[0].MeetingAttendedNumber === undefined) {
        MeetingAttendedNumber = ""
      }
      else {
        MeetingAttendedNumber = data.DirectorContact[0].MeetingAttendedNumber;
      }
    }
    else {
      MeetingAttendedNumber = data.DirectorProfessional[0].MeetingAttendedNumber;
    }

    // 7>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].Commission === undefined) {
      if (data.DirectorContact[0].Commission === undefined) {
        Commission = ""
      }
      else {
        Commission = data.DirectorContact[0].Commission;
      }
    }
    else {
      Commission = data.DirectorProfessional[0].Commission;
    }


    // 8>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].Remuneration === undefined) {
      if (data.DirectorContact[0].Remuneration === undefined) {
        Remuneration = ""
      }
      else {
        Remuneration = data.DirectorContact[0].Remuneration;
      }
    }
    else {
      Remuneration = data.DirectorProfessional[0].Remuneration;
    }

    // 9>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].DSCSigningDate === undefined) {
      if (data.DirectorContact[0].DSCSigningDate === undefined) {
        DSCSigningDate = null
      }
      else {
        DSCSigningDate = data.DirectorContact[0].DSCSigningDate;
      }
    }
    else {
      DSCSigningDate = data.DirectorProfessional[0].DSCSigningDate;
    }


    // 10>-------------------------------------------------------------------
    if (data.DirectorProfessional[0].DisqualifiedDirector === undefined) {
      if (data.DirectorContact[0].DisqualifiedDirector === undefined) {
        DisqualifiedDirector = ""
      }
      else {
        DisqualifiedDirector = data.DirectorContact[0].DisqualifiedDirector;
      }
    }
    else {
      DisqualifiedDirector = data.DirectorProfessional[0].DisqualifiedDirector;
    }


    // ------------------------>>>>>>>>New Fields...
    if (DesignationDIR12FillingDate != null) {
      dt = new Date(this.setFormatDate(DesignationDIR12FillingDate));
      this.DesignationDIR12FillingDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    if (DSCSigningDate != null) {
      dt = new Date(this.setFormatDate(DSCSigningDate));
      this.DSCSigningDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
    }
    this.directorProfessionalDetailsForm.controls.FunctionalAreas.setValue(FunctionalAreas);
    this.directorProfessionalDetailsForm.controls.AllMeetingSittingFees.setValue(AllMeetingSittingFees);
    this.directorProfessionalDetailsForm.controls.MeetingAttendedNumber.setValue(MeetingAttendedNumber);
    this.directorProfessionalDetailsForm.controls.Commission.setValue(Commission);
    this.directorProfessionalDetailsForm.controls.Remuneration.setValue(Remuneration);
    this.directorProfessionalDetailsForm.controls.DisqualifiedDirector.setValue(DisqualifiedDirector);
    this.directorProfessionalDetailsForm.controls.PromoterGroupDirector.setValue(PromoterGroupDirector);
    this.directorProfessionalDetailsForm.controls.IsSittingFeesEligible.setValue(IsSittingFeesEligible);

    // ---------------->>>>>>>>>>New Fields

  }



  addToKMP() {
    // isKmp
    this.activatedRoute.params.subscribe(params => {
      if (params['directorId'] != undefined) {
        if (this.directorContactDetailsForm.status == "VALID") {
          var varagendaCompliance = $('.select2').val();
          var updateDirector = {
            "Director":
            {
              _id: localStorage.getItem('updateDirectorId'),
              CompanyID: null,
              Din: this.directorMasterForm.controls.Din.value,
              FirstName: this.directorMasterForm.controls.FirstName.value.trim(),
              MiddleName: this.directorMasterForm.controls.MiddleName.value.trim(),
              LastName: this.directorMasterForm.controls.LastName.value.trim(),
              FatherFirstName: this.directorMasterForm.controls.FatherFirstName.value.trim(),
              FatherMiddleName: this.directorMasterForm.controls.FatherMiddleName.value.trim(),
              FatherLastName: this.directorMasterForm.controls.FatherLastName.value.trim(),
              MotherFirstName: this.directorMasterForm.controls.MotherFirstName.value.trim(),
              MotherMiddleName: this.directorMasterForm.controls.MotherMiddleName.value.trim(),
              MotherLastName: this.directorMasterForm.controls.MotherLastName.value.trim(),
              DateOfBirth: this.setDate(this.directorMasterForm.controls.DateOfBirth.value),
              BirthPlace: this.directorMasterForm.controls.BirthPlace.value.trim(),
              Gender: this.directorMasterForm.controls.Gender.value,
              Nationality: this.directorMasterForm.controls.Nationality.value,
              Resident: this.directorMasterForm.controls.Resident.value,
              Occupation: this.directorMasterForm.controls.Occupation.value.trim(),
              EducationalQualification: this.directorMasterForm.controls.EducationalQualification.value.trim(),
              PAN: this.directorMasterForm.controls.PAN.value.toUpperCase(),
              EmailID: this.directorMasterForm.controls.EmailID.value,
              IsMarried: this.directorMasterForm.controls.IsMarried.value,
              SpouseFirstName: this.directorMasterForm.controls.SpouseFirstName.value.trim(),
              SpouseMiddleName: this.directorMasterForm.controls.SpouseMiddleName.value.trim(),
              SpouseLastName: this.directorMasterForm.controls.SpouseLastName.value.trim(),
              ModifiedBy: null,
              ModifiedDate: this.setDate(new Date())
            }
          }
          var updateContactDetails = {
            "ContactDetails":
            {
              _id: localStorage.getItem('contactDetailId'),
              DirectorID: localStorage.getItem('updateDirectorId'),
              PermenantResidentialAddress: {
                PinCode: this.PermenantResidentialAddress.controls.PinCode.value.trim(),
                City: this.PermenantResidentialAddress.controls.City.value.trim(),
                State: this.PermenantResidentialAddress.controls.State.value,
                Country: this.PermenantResidentialAddress.controls.Country.value,
                Line2: this.PermenantResidentialAddress.controls.Line2.value.trim(),
                Line1: this.PermenantResidentialAddress.controls.Line1.value.trim()
              },
              PresentResidentialAddress: {
                PinCode: this.PresentResidentialAddress.controls.PinCode.value.trim(),
                City: this.PresentResidentialAddress.controls.City.value.trim(),
                State: this.PresentResidentialAddress.controls.State.value,
                Country: this.PresentResidentialAddress.controls.Country.value,
                Line2: this.PresentResidentialAddress.controls.Line2.value.trim(),
                Line1: this.PresentResidentialAddress.controls.Line1.value.trim()
              },
              OfficeAddress: {
                PinCode: this.OfficeAddress.controls.PinCode.value.trim(),
                City: this.OfficeAddress.controls.City.value.trim(),
                State: this.OfficeAddress.controls.State.value,
                Country: this.OfficeAddress.controls.Country.value,
                Line2: this.OfficeAddress.controls.Line2.value.trim(),
                Line1: this.OfficeAddress.controls.Line1.value.trim()
              },
              OfficeTelephoneNumber: this.directorContactDetailsForm.controls.OfficeTelephoneNumber.value,
              ResidentTelephoneNumber: this.directorContactDetailsForm.controls.ResidentTelephoneNumber.value,
              Fax: this.directorContactDetailsForm.controls.Fax.value,
              MobileNumber: this.directorContactDetailsForm.controls.MobileNumber.value,
              AadhaarNumber: this.directorContactDetailsForm.controls.AadhaarNumber.value.trim(),
              IdentityNumber: this.directorContactDetailsForm.controls.IdentityNumber.value.trim(),
              PassportNumber: this.directorContactDetailsForm.controls.PassportNumber.value.trim(),
              DrivingLicenseNumber: this.directorContactDetailsForm.controls.DrivingLicenseNumber.value.trim(),
              // FunctionalAreas: this.directorContactDetailsForm.controls.FunctionalAreas.value.trim(),
              // DesignationDIR12FillingDate: this.setDate(this.directorContactDetailsForm.controls.DesignationDIR12FillingDate.value),
              // PromoterGroupDirector: this.directorContactDetailsForm.controls.PromoterGroupDirector.value,
              // IsSittingFeesEligible: this.directorContactDetailsForm.controls.IsSittingFeesEligible.value,
              // AllMeetingSittingFees: this.directorContactDetailsForm.controls.AllMeetingSittingFees.value,
              // MeetingAttendedNumber: this.directorContactDetailsForm.controls.MeetingAttendedNumber.value,
              // Commission: this.directorContactDetailsForm.controls.Commission.value,
              // Remuneration: this.directorContactDetailsForm.controls.Remuneration.value,
              // DSCSigningDate: this.setDate(this.directorContactDetailsForm.controls.DSCSigningDate.value),
              // DisqualifiedDirector: this.directorContactDetailsForm.controls.DisqualifiedDirector.value,
              ModifiedBy: null,
              ModifiedDate: this.setDate(new Date())
            }
          }
          var updateDirectorProfessionalDetails = {
            "ProfessionalDetails":
            {
              _id: localStorage.getItem('professionalDetailId'),
              DirectorID: localStorage.getItem('updateDirectorId'),
              IsExecutive: this.directorProfessionalDetailsForm.controls.IsExecutive.value,
              IsRetiringDirector: this.directorProfessionalDetailsForm.controls.IsRetiringDirector.value,
              Designation: this.directorProfessionalDetailsForm.controls.Designation.value,
              Category: this.directorProfessionalDetailsForm.controls.Category.value,
              BoardResolutionDate: this.setDate(this.directorProfessionalDetailsForm.controls.BoardResolutionDate.value),
              AppointmentDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentDate.value),
              AppointmentDIR12FillingDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentDIR12FillingDate.value),
              PreAppointmentDates: varagendaCompliance,//this.setDate(this.directorProfessionalDetailsForm.controls.PreAppointmentDates.value),
              ReAppointmentDate: this.setDate(this.directorProfessionalDetailsForm.controls.ReAppointmentDate.value),
              CessationDate: this.setDate(this.directorProfessionalDetailsForm.controls.CessationDate.value),
              ResignationDIR11filingDate: this.setDate(this.directorProfessionalDetailsForm.controls.ResignationDIR11filingDate.value),
              CessationType: this.directorProfessionalDetailsForm.controls.CessationType.value,
              CessationReason: this.directorProfessionalDetailsForm.controls.CessationReason.value.trim(),
              AppointmentCompletionDate: this.setDate(this.directorProfessionalDetailsForm.controls.AppointmentCompletionDate.value),
              DisqualificationDate: this.setDate(this.directorProfessionalDetailsForm.controls.DisqualificationDate.value),
              DisqualificationDetails: this.directorProfessionalDetailsForm.controls.DisqualificationDetails.value.trim(),
              RemovalDIR12FilingDate: this.setDate(this.directorProfessionalDetailsForm.controls.RemovalDIR12FilingDate.value),
              RemovalDate: this.setDate(this.directorProfessionalDetailsForm.controls.RemovalDate.value),
              NoticeReceivedDate: this.setDate(this.directorProfessionalDetailsForm.controls.NoticeReceivedDate.value),
              ResignationEffectiveDate: this.setDate(this.directorProfessionalDetailsForm.controls.ResignationEffectiveDate.value),
              IsChairman: this.directorProfessionalDetailsForm.controls.IsChairman.value,
              OtherCessationType: this.directorProfessionalDetailsForm.controls.OtherCessationType.value,

              FunctionalAreas: this.directorProfessionalDetailsForm.controls.FunctionalAreas.value.trim(),
              DesignationDIR12FillingDate: this.setDate(this.directorProfessionalDetailsForm.controls.DesignationDIR12FillingDate.value),
              PromoterGroupDirector: this.directorProfessionalDetailsForm.controls.PromoterGroupDirector.value,
              IsSittingFeesEligible: this.directorProfessionalDetailsForm.controls.IsSittingFeesEligible.value,
              AllMeetingSittingFees: this.directorProfessionalDetailsForm.controls.AllMeetingSittingFees.value,
              MeetingAttendedNumber: this.directorProfessionalDetailsForm.controls.MeetingAttendedNumber.value,
              Commission: this.directorProfessionalDetailsForm.controls.Commission.value,
              Remuneration: this.directorProfessionalDetailsForm.controls.Remuneration.value,
              DSCSigningDate: this.setDate(this.directorProfessionalDetailsForm.controls.DSCSigningDate.value),
              DisqualifiedDirector: this.directorProfessionalDetailsForm.controls.DisqualifiedDirector.value,

              ModifiedBy: null,
              ModifiedDate: this.setDate(new Date())
            }
          }

          var DirectorData = {
            Director: updateDirector.Director,
            ContactDetails: updateContactDetails.ContactDetails,
            ProfessionalDetails: updateDirectorProfessionalDetails.ProfessionalDetails
          };


          this.DirectorMasterService.addThisDirectorAsKMP(DirectorData)
            .subscribe(directorData => {
              if (directorData.status == 0) {
                console.log(directorData.CreatedKMP);
                this.alert.successWithOk("Director Added to KMP successfully.", 'KMP/edit/' + directorData.CreatedKMP);
                localStorage.setItem('checktab', "checktab");
              }
              else {
                this.alert.error(directorData.message);
              }
            });
        }
      }
      else {
        this.isKmp = true;
      }

    })

  }


  redirectToKMP() {
    this.activatedRoute.params.subscribe(params => {

      if (params['directorId'] != undefined) {
        this.router.navigate(
          [{ outlets: { 'structure-outlet': ['KMP','edit',this.availableKMPID]  } }],
          { relativeTo: this.activatedRoute.parent });
        // this.router.navigate(['/KMP/edit/' + this.availableKMPID]);
      }
      else {

      }

    })
  }


  showEditCompanyNamePopup() {

    // this.closeAllFieldEditPopup();
    $('#companyName').parent().addClass('editMode');
    var width = $('#companyName').parent().outerWidth();
    $('#edit-companyName-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  hideEditCompanyNamePopup() {

    // this.closeAllFieldEditPopup();
    $('#companyName').parent().removeClass('editMode');
    var width = $('#companyName').parent().outerWidth();
    $('#edit-companyName-popup').hide();
  }

  preAppointmentDate: any;

  preAppointmentDateschange(value: NgbDateStruct[]) {
    // console.log(value);
    this.datesSelected = value;
    this.preAppointmentDate = [];
    this.datesSelected.forEach(element => {
      console.log('This.Elemet', element);
      this.preAppointmentDate = element.day + '-' + element.month + '-' + element.year + ' ,' + this.preAppointmentDate;
      this.preAppointmentDate = this.preAppointmentDate.replace(/,\s*$/, "");
    })
  }

  removePreAppDate(index) {
    console.log(index);
    this.datesSelected.splice(index, 1)
  }

  checkAppointmentDateDirector() {
    var dateOfIncorporation = JSON.parse(localStorage.getItem('dateOfIncorporation'));
    var appointmentDate = this.directorProfessionalDetailsForm.controls.AppointmentDate.value
    var diffAppointmentDateAndDateOfIncorporation = (moment(dateOfIncorporation).diff(moment(appointmentDate), "days"));

    if (diffAppointmentDateAndDateOfIncorporation > 0) {
      this.disabledAppointmentDateDirector = true;
    }
    else {
      this.disabledAppointmentDateDirector = false;
    }
  }

 onMarriedToggle(event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  // Toggle is ON (Yes) if checked === true, OFF (No) if false
  if (checked) {
    // Yes logic
    this.showMarridYesClick();
  } else {
    // No logic
    this.hideMarridYesClick();
  }
}

onResidentToggle(event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  // "Yes" logic if checked === true, "No" logic if checked === false
  // Optional: patch other form values or perform side effects here
}


}






